import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import moment from "moment";
import * as ReactBootStrap from 'react-bootstrap';

import Departamentos from '../API/Departamentos';
import Publicaciones from './Publicaciones_prestador'

import telefono from '../tools/images/icono telefono whatsApp.svg'

import platinium from '../tools/images/PLATINIUM.png'
import golden from '../tools/images/GOLDEN.png'
import diamond from '../tools/images/DIAMOND.png'
import silver from '../tools/images/Silver-profesional-1.png'

import paso1 from '../tools/images/paso1compra.svg'
import paso2 from '../tools/images/paso2compra.svg'
import paso3 from '../tools/images/paso3compra.svg'
import card_credit from '../tools/images/credit-card.svg';
import pse from '../tools/images/pse.png';
import bancolombia from '../tools/images/bancolombia.png';
import nequi from '../tools/images/nequi.png';

import '../tools/css/Perfil.css';

import cargamultimedia from '../tools/images/iconocargarfoto.svg'

import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';


import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL="https://medicall-api-test.azurewebsites.net";
var institution_id =sessionStorage.getItem('id_institution');
var identi_profe =sessionStorage.getItem('identificacion_profesional');

// Supabase (catálogo de planes / suscripciones): API pública con su propia
// apikey, distinta de la API de Medicall24. Se usa una instancia de axios
// aparte (sin el interceptor de Navbar.js) para que no le pise el header
// Authorization con el token de Medicall24.
const SUPABASE_URL = "https://ukvjbkxaqzltngpbrdfi.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVrdmpia3hhcXpsdG5ncGJyZGZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYyODE5NTcsImV4cCI6MjA1MTg1Nzk1N30.3CrdWxYa5Rme_1Zbhi3peYRfsA35j4eUnPZyWlMsQ1M";
const axiosSupabase = axios.create({
  headers: {
    apikey: SUPABASE_ANON_KEY,
    Authorization: "Bearer " + SUPABASE_ANON_KEY
  }
});
var avatar=[];
var cover=[];
var mensaje='';
var files_view='';
var files_viewp='';
var muni='';
var idmuni_edit='0';
var depa='';
var iddepa_edit='0';
var claseprestador_edit='';
var naturaleza_edit='';
var nivelatencion_edit='0';
var ese='No';
var ese_edit=null;
var tipoidrl_edit=null;
var url='';
var url_pse='';
var tipo_membresia='0';
var metodo_pago='';
var tipo_persona='';
var status='';
var valor = 0;
var iva = 0;
var ambientefe=0;
var tipo_regimenfe=0;
var tipo_reponsabilidadfe=0;




class Perfil extends Component {

  constructor(props)
    {
     super()
      this.state={
        show:false,
        DataIntitucion: [],    
        DataMembresia: [],   
        Membresia:[],
        Detalle_membresia:[],
        Detalle_compra:[],
        Suscripcion_vigente: null,
        Suscripciones: [],
        MetodoPago: null,
        cargando_suscripcion: false,
        CatalogoPlanes: [],
        cargando_catalogo_planes: false,
        planSeleccionado: null,
        Pager_Publicacione: [],
        imgs:[],
        Departamentos: [],
        Municipios:[],
        Bancos:[],
        Slug_ambientes:[],
        Slug_regimenes:[],
        Slug_responsabilidades:[],
        Slug_tipodocumento:[],
        Data_configuracionFE:[],
        Data_resolucionesFE:[],
        pasoFacturacion:1,
        pager_infopublicacione:'',
        loading: false,
        loading_recurso:false,
        loading_button: true,
        active_button: true,
        loading_button_img: true,
        active_button_img: true,
          
        form:{ 
        id_inst:'',  
        nombre_edit:"",
        nombre1_edit:"",
        nombre2_edit:"",
        apell1_edit:"",
        apell2_edit:"",
        codigoprestador_edit:'',       
        correo_edit:'',
        web_edit:'',
        dir_edit:'',
        tel1_edit:'',
        tel2_edit:'',
        idrl_edit:'',
        nom1rl_edit:"",
        nom2rl_edit:"",
        apell1rl_edit:"",
        apell2rl_edit:"",
        selectedFile:null,
        selectedFilep:null,
        claseprestado:'',
        nivelatencion:'',
        municipio:'',
        departamento:'',
        llave_publi:'',
        llave_priv:'',
        llave_eventos:'',
        llave_integridad:'',
        tipoid_comprador_general:'null',
        id_comprador_general:'',
        nombres_comprador_general:'',
        apellidos_comprador_general:'',
        correo_comprador_general:'',
        dir_comprador_general:'',
        tel_comprador_general:'',
        num_tc:'',
        tarjetahabiente:'',
        mes_tc:'',
        year_tc:'',
        cuotas_tc:'1',
        cod_tc:'',
        tipodcto_pse:'CC',
        numerodcto_pse:'',
        id_banco_pse:'',
        cel_nequi:'',
        cod_membresia1:'',
        cod_membresia2:'',
        cod_membresia3:'',
        cod_membresia4:'',
        cod_membresia5:'',
        softwareId:'',
        softwarePin:'',
        testSetId:'',
        merchantRegistration:'',
        ambiente:0,
        typeRegimeId:0,
        typeLiabilityId:0,
        tipo_factura:'',
        tipodocumento_dian:0,
        num_resolucion:'',
        fecha_resolucion:'',
        prefijo:'',
        rango_desde:'',
        rango_hasta:'',
        claveTecnica:'',
        fechainicio_resolucion:'',
        fechavencimiento_resolucion:'',
        claveCertificado:'',
        firma_cer_base64:'',
        certificadoP12Nombre:''

        }
        
      }
    }



    handleChange=async e=>{
      await this.setState({
         form:{
              ...this.state.form,
              [e.target.name]: e.target.value
              }
         })
         //console.log(this.state.form);
    }

    /** Ambiente DIAN seleccionado para la configuración de facturación electrónica. */
    GetAmbienteDIAN=(e)=>{
      ambientefe = e.target.value
      this.setState({ form:{ ...this.state.form, ambiente: e.target.value } })
    }

    /** Régimen DIAN seleccionado para la configuración de facturación electrónica. */
    GetRegimenDIAN=(e)=>{
      tipo_regimenfe = e.target.value
      this.setState({ form:{ ...this.state.form, typeRegimeId: e.target.value } })
    }

    /** Responsabilidad tributaria DIAN seleccionada para la configuración de facturación electrónica. */
    GetresponsabilidadDIAN=(e)=>{
      tipo_reponsabilidadfe = e.target.value
      this.setState({ form:{ ...this.state.form, typeLiabilityId: e.target.value } })
    }

    Campo_numerico(){
      $(".camponum").keypress(function(tecla)
      {
        if(tecla.charCode<48 || tecla.charCode>57){
         
          return false;

        }
      })
    }


    GetImg = (i) =>{      
      this.setState({selectedFile:i.target.files})
      avatar=i.target.files[0]
      files_view=URL.createObjectURL(i.target.files[0]); 
       
      this.modal_img_perfil() 
      //alert(avatar)
    }

    GetImg_portada = (ip) =>{     
      this.setState({selectedFilep:ip.target.files})
      cover=ip.target.files[0]
      files_viewp=URL.createObjectURL(ip.target.files[0]);
      
      this.modal_img_portada() 
      //alert(cover)
    }


    modal_img_perfil(){
      $('#modal_img_perfil').modal('show'); 
    }

    modal_img_portada(){
      $('#modal_img_portada').modal('show'); 
    }

    modal_detalle_silver_independiente(){
      $('#modal_detalle_silver_independiente').modal('show'); 
    }

    modal_detalle_golden_independiente(){
      $('#modal_detalle_golden_independiente').modal('show'); 
    }

    modal_detalle_platinum_institucion(){
      $('#modal_detalle_platinum_institucion').modal('show'); 
    }

    modal_detalle_golden_institucion(){
      $('#modal_detalle_golden_institucion').modal('show'); 
    }

    modal_detalle_diamond_institucion(){
      $('#modal_detalle_diamond_institucion').modal('show'); 
    }


    modal_comprar_membresia(tipo_membresia){

      $('#modal_detalle_silver_independiente').modal('hide'); 
      $('#modal_detalle_golden_independiente').modal('hide'); 
      $('#modal_detalle_platinum_institucion').modal('hide');
      $('#modal_detalle_golden_institucion').modal('hide'); 
      $('#modal_detalle_diamond_institucion').modal('hide');
      
      axios.get(ApiURL+"/api/Products/GetById/"+tipo_membresia)
      .then((response) => {
        console.log(response.data);
        this.setState({Detalle_membresia: response.data}) 

        $('#modal-compramembresia').modal('show'); 

      })
      .catch((error) => {
        console.log(error);
      })     

    }

    modal_activamembresia(){      
      $('#modal-activarmembresia').modal('show');
      $("#modal-activarmembresia input").val("");
      
      //this.setState({ active_buttonrecovery_pass: this.state.active_buttonrecovery_pass = true })
    }

    modal_llavesWOMPI(){   
      
      $('#modal-llaveswompi').modal('show'); // <- to show modal llaves wompi
    }

   

    dropmodal_comprar_membresia() {

      $("#modal-compramembresia input").val("");
      $("#modal-compramembresia input[type='radio']").prop('checked', false).change();      
      $("#tipoid_comprador_general").val($('#tipoid_comprador_general > option:first').val());
      $("#mes_tc").val($('#mes_tc > option:first').val());
      $("#year_tc").val($('#year_tc > option:first').val());
      $("#cuotas_tc").val($('#cuotas_tc > option:first').val());
      $("#cuotas_tc").val($('#cuotas_tc > option:first').val());
      $("#tipo_persona_pse").val($('#tipo_persona_pse > option:first').val());
      $("#id_banco_pse").val($('#id_banco_pse > option:first').val());


      this.setState({
        form:{
          tipoid_comprador_general:'null',
          id_comprador_general:'',
          nombres_comprador_general:'',
          apellidos_comprador_general:'',
          correo_comprador_general:'',
          dir_comprador_general:'',
          tel_comprador_general:'',    
          num_tc:'',
          tarjetahabiente:'',
          mes_tc:'MM',
          year_tc:'YY',
          cuotas_tc:'1',
          cod_tc:'',
          tipodcto_pse:'CC',
          numerodcto_pse:'',
          id_banco_pse:'',
          cel_nequi:''     
        }
      }) 
      
      this.Drop_formularios_pagos();
    }

    handleModaleditinfo()
    { 
      this.cargar_departamentos();
      this.seleccionardatos();    
      $('#modal-infoinstotucion').modal('show'); // <- to show modal editar informacion de institucion
    }

    

    drop_view_img(){
      files_view=null
      files_viewp=null
    }   
    
    hidedepartamento(){
     
    }

    cargar_departamentos(){    
    
      axios.get("https://medicall-api-test.azurewebsites.net/api/Departments/ListDepartments")
      .then((response) => {
        //console.log(response);
        this.setState({Departamentos: response.data})

        $('#cb_departamento').hide();
      })
      .catch((error) => {
        //console.log(error);
      })
    }

    Cargar_Slug_DIAN(){

      this.Slug_DIAN_ambientes();
      this.Slug_DIAN_regimenes();
      this.Slug_DIAN_responsabilidades();
      this.Slug_DIAN_tipodocumento();
      this.Configuracion_FE();
      this.Listar_resolucionFE();

    }



    Configuracion_FE(){

      axios.get("https://medicall-api-test.azurewebsites.net/api/PrestadorFe")
      .then((response) => {
        console.log(response);
        this.setState({
          Data_configuracionFE: response.data,
          form:{
            ...this.state.form,
            softwareId: response.data.softwareId || '',
            softwarePin: response.data.softwarePin || '',
            testSetId: response.data.testSetId || '',
            merchantRegistration: response.data.merchantRegistration || '',
            ambiente: response.data.ambiente || 0,
            typeRegimeId: response.data.typeRegimeId || 0,
            typeLiabilityId: response.data.typeLiabilityId || 0
          }
        })

        ambientefe=response.data.ambiente
        tipo_regimenfe=response.data.typeRegimeId
        tipo_reponsabilidadfe=response.data.typeLiabilityId


      })
      .catch((error) => {
        //console.log(error);
      })
    }


    Listar_resolucionFE(){

      axios.get("https://medicall-api-test.azurewebsites.net/api/PrestadorFe/Resoluciones")
      .then((response) => {
        console.log(response);
        const resolucion = response.data[0] || {}
        this.setState({
          Data_resolucionesFE: resolucion,
          form:{
            ...this.state.form,
            tipo_factura: resolucion.tipoDocumento || '',
            tipodocumento_dian: resolucion.typeDocumentId || 0,
            num_resolucion: resolucion.numeroResolucion || '',
            fecha_resolucion: resolucion.fechaResolucion ? resolucion.fechaResolucion.split("T")[0] : '',
            prefijo: resolucion.prefijo || '',
            rango_desde: resolucion.rangoDesde || '',
            rango_hasta: resolucion.rangoHasta || '',
            claveTecnica: resolucion.claveTecnica || '',
            fechainicio_resolucion: resolucion.fechaDesde ? resolucion.fechaDesde.split("T")[0] : '',
            fechavencimiento_resolucion: resolucion.fechaHasta ? resolucion.fechaHasta.split("T")[0] : ''
          }
        })

      })
      .catch((error) => {
        //console.log(error);
      })
    }
    
    
    Slug_DIAN_ambientes(){    
    
      axios.get("https://medicall-api-test.azurewebsites.net/api/DianCatalogs/ambientes")
      .then((response) => {
        console.log(response);
        this.setState({Slug_ambientes: response.data.items})

        
      })
      .catch((error) => {
        //console.log(error);
      })
    } 


    Slug_DIAN_regimenes(){    
    
      axios.get("https://medicall-api-test.azurewebsites.net/api/DianCatalogs/regimenes")
      .then((response) => {
        console.log(response);
        this.setState({Slug_regimenes: response.data.items})

       
      })
      .catch((error) => {
        //console.log(error);
      })
    } 


    Slug_DIAN_responsabilidades(){    
    
      axios.get("https://medicall-api-test.azurewebsites.net/api/DianCatalogs/responsabilidades")
      .then((response) => {
        console.log(response);
        this.setState({Slug_responsabilidades: response.data.items})

        
      })
      .catch((error) => {
        //console.log(error);
      })
    } 


    Slug_DIAN_tipodocumento(){    
    
      axios.get("https://medicall-api-test.azurewebsites.net/api/DianCatalogs/tipos-documento")
      .then((response) => {
        console.log(response);
        this.setState({Slug_tipodocumento: response.data.items})

        
      })
      .catch((error) => {
        //console.log(error);
      })
    }


    Guardar_configuracionFE=async()=>{    
    
            if(ambientefe==0 || tipo_regimenfe==0 || tipo_reponsabilidadfe==0 || this.state.form.softwareId=='' || this.state.form.softwarePin=='' || this.state.form.testSetId=='' || this.state.form.merchantRegistration==''){
    
              store.addNotification({
                title: 'Atención',
                message: "Faltan datos por ingresar",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
    
            }else{
    
              this.setState({ loading_button: this.state.loading_button = false })
              this.setState({ active_button: this.state.active_button = false })
    
              await axios.put(ApiURL+"/api/PrestadorFe",
        
                {
                  softwareId: this.state.form.softwareId,
                  softwarePin: this.state.form.softwarePin,
                  ambiente: ambientefe,
                  testSetId: this.state.form.testSetId,
                  merchantRegistration: this.state.form.merchantRegistration,
                  typeRegimeId: tipo_regimenfe,
                  typeLiabilityId: tipo_reponsabilidadfe
                } )  
        
              .then(response=>{
                console.log(response.data)
                mensaje  = response.data.message;
               
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);
                      
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
    
                
              })
              .catch(error=>{
                  
                if (error.response) {
                  /*
                  * The request was made and the server responded with a
                  * status code that falls out of the range of 2xx
                  */
                  //console.log(error.response.data.message);
                  //console.log(error.response.status);
                  //console.log(error.response.headers);
                  mensaje=error.response.data.message
                  
                  store.addNotification({
                    title: 'Atención',
                    message: mensaje,
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
    
                  this.setState({ loading_button: this.state.loading_button = true })
                  this.setState({ active_button: this.state.active_button = true })
    
              } else if (error.request) {
                  /*
                  * The request was made but no response was received, `error.request`
                  * is an instance of XMLHttpRequest in the browser and an instance
                  * of http.ClientRequest in Node.js
                  */
                  console.log(error.request);
                  this.setState({ loading_button: this.state.loading_button = true })
                  this.setState({ active_button: this.state.active_button = true })
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
                  this.setState({ loading_button: this.state.loading_button = true })
                  this.setState({ active_button: this.state.active_button = true })
              }
              //console.log(error.config);
            
            })
    
            }

    }

    /** Navega entre los pasos del asistente de facturación electrónica (1 a 3). */
    irPasoFacturacion=(paso)=>{
      if(paso<1 || paso>3) return
      this.setState({ pasoFacturacion: paso }, ()=>{
        $('[data-toggle="tooltip"]').tooltip()
      })
    }

    /** Guardado de la resolución de facturación: pendiente de endpoint en el backend. */
    Guardar_resolucionFE_pendiente=()=>{
      store.addNotification({
        title: 'Próximamente',
        message: 'El guardado de la resolución de facturación aún no está disponible.',
        type: 'info',
        container: 'top-right',
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 8000, showIcon:true }
      })
    }

    /** Guardado del certificado digital: pendiente de endpoint en el backend. */
    Guardar_certificadoFE_pendiente=()=>{
      store.addNotification({
        title: 'Próximamente',
        message: 'La carga del certificado digital aún no está disponible.',
        type: 'info',
        container: 'top-right',
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 8000, showIcon:true }
      })
    }

    /** Lee un archivo .p12 seleccionado por el usuario y lo convierte a Base64 para "Firma Base64". */
    ConvertirCertificadoP12Base64=(e)=>{
      const archivo = e.target.files[0]
      if(!archivo) return

      const lector = new FileReader()

      lector.onload = () => {
        const base64 = lector.result.split(',')[1] || ''
        this.setState({
          form:{
            ...this.state.form,
            firma_cer_base64: base64,
            certificadoP12Nombre: archivo.name
          }
        })
        store.addNotification({
          title: 'Listo',
          message: 'Certificado convertido a Base64 correctamente.',
          type: 'success',
          container: 'top-right',
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 6000, showIcon:true }
        })
      }

      lector.onerror = () => {
        store.addNotification({
          title: 'Atención',
          message: 'No se pudo leer el archivo del certificado.',
          type: 'danger',
          container: 'top-right',
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 8000, showIcon:true }
        })
      }

      lector.readAsDataURL(archivo)
      e.target.value = ''
    }

    /** Vacía el campo "Firma Base64" y el nombre del certificado convertido. */
    LimpiarFirmaBase64=()=>{
      this.setState({
        form:{
          ...this.state.form,
          firma_cer_base64: '',
          certificadoP12Nombre: ''
        }
      })
    }


    GetDepartamento = (d) =>{
      console.log(d.target.value)
      iddepa_edit=(d.target.value)  
      this.Cargar_Municipios(iddepa_edit)

      idmuni_edit='0';
      muni='Seleccione...'
    }

    GetMunicipio = (m) =>{
     
      console.log(m.target.value)
      idmuni_edit=(m.target.value)  
     
    }

    GetClasepres = (cp) =>{     
      console.log(cp.target.value)
      claseprestador_edit=(cp.target.value)

      $('#cb_claseprestador').hide();
      //this.Cuota_mod();
     
    }

    GetTipoNatu = (tn) =>{
 
      console.log(tn.target.value)
      naturaleza_edit=(tn.target.value)

      $('#cb_naturaleza').hide();
      //this.Cuota_mod();
     
    }

    GetNivel = (n) =>{
     
      console.log(n.target.value)
      nivelatencion_edit=(n.target.value)  

      $('#cb_nivel').hide();     
    }

    GetESE = (e) =>{
      
      console.log(e.target.value)
      ese_edit=(e.target.value) 

      $('#cb_ese').hide();      
    }

    GetTipoIDLD = (tild) =>{
     
      console.log(tild.target.value)
      tipoidrl_edit=(tild.target.value)

      $('#cb_tipoid_rl').hide();
    }

    GetMetodopago = (mp) =>{
     
      //console.log(mp.target.value)
      metodo_pago=(mp.target.value)

      this.Formulario_metodopago();
     
    }

    GetTipopersona = (tp) =>{
     
      //console.log(tp.target.value)
      tipo_persona=(tp.target.value)
    
     
    }

    Formulario_metodopago(){     
      if(metodo_pago==='CARD'){
  
        $('#tarjeta_credito').show();
        $('#pse').hide();
        $('#bancolombia').hide();
        $('#nequi').hide();


      }else{

        if(metodo_pago==='PSE'){

          $('#tarjeta_credito').hide();
          $('#pse').show();
          $('#bancolombia').hide();
          $('#nequi').hide();

          tipo_persona='';

          $("#tipo_persona_pse").val($('#tipo_persona_pse > option:first').val());

        }else{

          if(metodo_pago==='BANCOLOMBIA_TRANSFER'){

            $('#tarjeta_credito').hide();
            $('#pse').hide();           
            $('#nequi').hide();

            tipo_persona='PERSON';

            $("#tipo_persona_pse").val($('#tipo_persona_pse > option:first').val());

         

          }else{

            if(metodo_pago==='NEQUI'){

              $('#tarjeta_credito').hide();
              $('#pse').hide();
              $('#bancolombia').hide();
              $('#nequi').show();

            }
          }
        }
      }
      
    }


    Datos_formulario_metodopago(){     
      if(metodo_pago==='CARD'){
  
        ese_edit=this.state.DataIntitucion.ese


      }else{

        if(metodo_pago==='PSE'){

          $('#tarjeta_credito').hide();
          $('#pse').show();
          $('#bancolombia').hide();
          $('#nequi').hide();

        }else{

          if(metodo_pago==='BANCOLOMBIA_TRANSFER'){

            $('#tarjeta_credito').hide();
            $('#pse').hide();
            $('#bancolombia').show();
            $('#nequi').hide();

          }else{

            if(metodo_pago==='NEQUI'){

              $('#tarjeta_credito').hide();
              $('#pse').hide();
              $('#bancolombia').hide();
              $('#nequi').show();

            }
          }
        }
      }
      
    }

    Drop_formularios_pagos(){

              $('#img_paso1').show();
              $('#img_paso2').hide();

              $('#compra_paso1').show();
              $('#compra_paso2').hide();

              $('#btn_compra_paso1').show();
              $('#btn_compra_paso2').hide();


              $('#tarjeta_credito').hide();
              $('#pse').hide();
              $('#bancolombia').hide();
              $('#nequi').hide();


    }


    Cargar_bancos(){    
    
      axios.get(ApiURL+"/api/Payments/FinancialInstitutions")
      .then((response) => {
        //console.log(response);
        this.setState({Bancos: response.data.data})
      })
      .catch((error) => {
        console.log(error);
      })
    }

    Cargar_membresias(){

      axios.get(ApiURL+"/api/Memberships/GetMembershipPlans")
      .then((response) => {
        console.log(response.data);
        this.setState({Membresia: response.data})
      })
      .catch((error) => {
        console.log(error);
      })
    }

    // Endpoint público (sin token ni api key) del ecosistema, distinto de la API de Medicall24.
    Cargar_Suscripcion(){

      this.setState({ cargando_suscripcion: false })

      institution_id = sessionStorage.getItem('id_institution')

      axios.get("https://ukvjbkxaqzltngpbrdfi.supabase.co/functions/v1/eco-prestador-get?identificacion="+identi_profe)
      .then((response) => {
        console.log(response.data);
        this.setState({
          Suscripcion_vigente: response.data.suscripcion_vigente,
          Suscripciones: response.data.suscripciones ? response.data.suscripciones : [],
          MetodoPago: response.data.metodo_pago ? response.data.metodo_pago : null,
          cargando_suscripcion: true
        })

        // Sin suscripción vigente, se necesita el catálogo para ofrecer los planes.
        if (!response.data.suscripcion_vigente) {
          this.Cargar_CatalogoPlanes()
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargando_suscripcion: true })
      })
    }

    Cargar_CatalogoPlanes(){

      this.setState({ cargando_catalogo_planes: false })

      axiosSupabase.get(SUPABASE_URL+"/rest/v1/eco_plan_catalog?select=*")
      .then((response) => {
        console.log(response.data);
        const filas = (response.data || []).filter((fila)=> String(fila.id) !== '1')
        this.setState({
          CatalogoPlanes: filas,
          planSeleccionado: filas.length ? filas[0].plan_id : null,
          cargando_catalogo_planes: true
        })
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargando_catalogo_planes: true })
      })
    }

    // Los nombres de los campos dentro de cada suscripción no están documentados,
    // así que se resuelven con alternativas por si el backend usa otra convención.
    Suscripcion_obtenerPlan(s){
      return (s && (s.plan_id || s.nombre_plan || s.tipo_plan || s.nombre)) || 'Plan sin nombre'
    }

    Suscripcion_obtenerInicio(s){
      return s ? (s.trial_started_at || s.vigencia_desde || s.fechaInicio || s.inicio) : null
    }
 
    Suscripcion_obtenerFin(s){
      return s ? (s.trial_ends_at || s.vigencia_hasta || s.fechaFin || s.fin) : null
    }

    Suscripcion_obtenerValor(s){
      const valor = s ? (s.monto_base_cop ?? s.precio ?? s.monto) : 0
      return Number(valor) || 0
    }

    Suscripcion_obtenerEstadoTexto(s){
      return (s && (s.estado || s.status)) || ''
    }

    Suscripcion_formatoMoneda(valor){
      return '$' + Number(valor || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 })
    }

    Suscripcion_capitalizar(texto){
      return (texto || '').trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
    }

    // Compara una fila del historial contra la suscripción vigente para saber si es la misma.
    Suscripcion_esVigente(s){
      const vigente = this.state.Suscripcion_vigente
      if (!vigente || !s) return false
      if (s.id !== undefined && vigente.id !== undefined) return s.id === vigente.id
      return this.Suscripcion_obtenerInicio(s) === this.Suscripcion_obtenerInicio(vigente)
        && this.Suscripcion_obtenerFin(s) === this.Suscripcion_obtenerFin(vigente)
    }

    Suscripcion_resolverEstadoVisual(s){
      if (this.Suscripcion_esVigente(s)) return { texto: 'Activa', claseBadge: 'badge-success' }

      const fechaFin = this.Suscripcion_obtenerFin(s)
      if (fechaFin && moment(fechaFin).isBefore(moment(), 'day')) return { texto: 'Vencida', claseBadge: 'badge-danger' }

      const estadoTexto = this.Suscripcion_obtenerEstadoTexto(s)
      if (estadoTexto) return { texto: this.Suscripcion_capitalizar(estadoTexto), claseBadge: 'badge-secondary' }

      return { texto: 'Inactiva', claseBadge: 'badge-secondary' }
    }

    // Los valores que devuelve el backend vienen en inglés (o en códigos cortos);
    // si el valor no está en el mapa, se muestra capitalizado tal cual llegue.
    Suscripcion_traducirPeriodoFacturacion(valor){
      const mapa = {
        monthly: 'Mensual',
        mensual: 'Mensual',
        yearly: 'Anual',
        annual: 'Anual',
        anual: 'Anual',
        quarterly: 'Trimestral',
        trimestral: 'Trimestral',
        biannual: 'Semestral',
        semiannual: 'Semestral',
        semestral: 'Semestral',
        weekly: 'Semanal',
        semanal: 'Semanal',
        daily: 'Diario',
        diario: 'Diario'
      }
      const clave = (valor || '').toString().trim().toLowerCase()
      return mapa[clave] || this.Suscripcion_capitalizar(valor)
    }

    Suscripcion_traducirTipoCompra(valor){
      const mapa = {
        new: 'Nueva',
        nueva: 'Nueva',
        renewal: 'Renovación',
        renovacion: 'Renovación',
        upgrade: 'Mejora de plan',
        downgrade: 'Cambio a plan menor',
        trial: 'Prueba',
        prueba: 'Prueba',
        reactivation: 'Reactivación',
        reactivacion: 'Reactivación'
      }
      const clave = (valor || '').toString().trim().toLowerCase()
      return mapa[clave] || this.Suscripcion_capitalizar(valor)
    }

    MetodoPago_formatoTarjeta(ultimos4){
      return ultimos4 ? ('•••• ' + ultimos4) : '-'
    }

    modal_metodospago(){
      $('#modal-metodospago').modal('show');
    }

    // Filas del catálogo agrupadas por plan_id (ya viene sin el plan_id=1, filtrado al cargar).
    Planes_agrupar(){
      const grupos = {}
      this.state.CatalogoPlanes.forEach((fila)=>{
        const clave = fila.plan_id
        if (!grupos[clave]) grupos[clave] = []
        grupos[clave].push(fila)
      })
      return grupos
    }

    // No hay un campo de "nombre" documentado para el plan, se resuelve con alternativas.
    Planes_obtenerNombre(fila){
      return (fila && (fila.plan_name || fila.nombre_plan || fila.plan_slug)) || ('Plan ' + (fila ? fila.plan_id : ''))
    }

    Planes_obtenerEtiquetaPeriodo(billing_period){
      const clave = (billing_period || '').toString().trim().toLowerCase()
      if (clave === 'annual' || clave === 'yearly' || clave === 'anual') {
        return { titulo: 'Precio por año', subtitulo: 'Suscripción por 12 meses', facturacion: 'Facturación anual' }
      }
      if (clave === 'monthly' || clave === 'mensual') {
        return { titulo: 'Precio por mes', subtitulo: 'Suscripción por 30 días', facturacion: 'Facturación mensual' }
      }
      return { titulo: this.Suscripcion_capitalizar(billing_period), subtitulo: '', facturacion: this.Suscripcion_capitalizar(billing_period) }
    }

    Planes_calcularPrecioAcsc(precioBase, descuentoPct){
      const base = Number(precioBase) || 0
      const descuento = Number(descuentoPct) || 0
      return Math.round(base - (base * descuento / 100))
    }

    Planes_formatoMoneda(valor){
      return this.Suscripcion_formatoMoneda(valor) + ' COP'
    }

    Planes_construirUrlSuscripcion(fila){
      const identificacion = sessionStorage.getItem('identificacion_profesional')
      return 'https://appmedicall24.com/ecosistema-medico-360/suscribir/registro'
        + '?plan=' + encodeURIComponent(fila.plan_id)
        + '&billing=' + encodeURIComponent(fila.billing_period)
        + '&id=' + encodeURIComponent(identificacion)
        + '&redirect=true'
    }


    Cargar_Municipios(iddepa_edit){
        
      axios.get(ApiURL+"/api/Departments/ListMunicipalties/"+iddepa_edit)
      .then((response) => {
        console.log(response);
        this.setState({Municipios: response.data})

        $('#cb_municipio').hide();
        $('#cb_municipio_seleccione').show();
        
      })
      .catch((error) => {
        console.log(error);
      })
    }  


   
    componentDidMount(){
      this.Datos_Institucion();
      this.Cargar_bancos();

      $('[data-toggle="tooltip"]').tooltip()
      $('#cb_municipio_seleccione').hide();

      $('#tarjeta_credito').hide();
      $('#pse').hide();
      $('#bancolombia').hide();
      $('#nequi').hide();
      $('#compra_paso2').hide();
      $('#compra_paso3').hide();
      $('#btn_compra_paso2').hide();  
      $('#btn_compra_paso3').hide();  
      $('#img_paso2').hide();  

      $('#institucion').hide();
      $('#independiente').hide();
          
      
    }

    validar_paso1(){

      if( this.state.form.tipoid_comprador_general=='null' || this.state.form.id_comprador_general.length==0 || this.state.form.nombres_comprador_general.length==0 || this.state.form.apellidos_comprador_general.length==0 || this.state.form.dir_comprador_general.length==0 || this.state.form.tel_comprador_general.length==0){
  
        store.addNotification({
          title: 'Atención',
          message: "Faltan datos del comprador por ingresar",
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

      }else{

        $('#img_paso1').hide();
        $('#img_paso2').show();

        $('#compra_paso1').hide();
        $('#compra_paso2').show();
  
        $('#btn_compra_paso1').hide();
        $('#btn_compra_paso2').show();

      }

      
    
    }

    atras(){

      $('#img_paso1').show();
      $('#img_paso2').hide();

      $('#compra_paso1').show();
      $('#compra_paso2').hide();
      $('#compra_paso3').hide();

      $('#btn_compra_paso1').show();
      $('#btn_compra_paso2').hide();
      $('#btn_compra_paso3').hide();
    
    }

    atras3(){

      $('#img_paso1').show();
      $('#img_paso2').hide();

      $('#compra_paso1').hide();
      $('#compra_paso2').show();
      $('#compra_paso3').hide();

      $('#btn_compra_paso1').hide();
      $('#btn_compra_paso2').show();
      $('#btn_compra_paso3').hide();
    
    }


    Datos_Institucion(){    
      
      axios.get(ApiURL+"/api/Institutions/GetInstitution/"+institution_id)
      .then((response) => {
        console.log(response);
        this.setState({DataIntitucion: response.data.institution})       
        this.setState({DataMembresia: response.data.membership})

        iddepa_edit= response.data.institution.department.id
        this.setState({departamento: response.data.institution.department.nombre})
        depa=(this.state.departamento).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
   
        idmuni_edit= response.data.institution.municipality.id
        this.setState({municipio: response.data.institution.municipality.nombre})
        muni=(this.state.municipio).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
     
        claseprestador_edit=this.state.DataIntitucion.providerClass
      
        naturaleza_edit=this.state.DataIntitucion.legalNature

        nivelatencion_edit=this.state.DataIntitucion.atentionLevel       

        tipoidrl_edit=this.state.DataIntitucion.tipeIdRepresentative

        if(this.state.DataIntitucion.providerClass=='ips'){
           this.setState({claseprestado: 'Instituciones - IPS'})
           $('#institucion').show();
           $('#independiente').hide();
        }else{
          if(this.state.DataIntitucion.providerClass=='profesional independiente'){
             this.setState({claseprestado: 'Profesional independiente'})
             $('#institucion').hide();
             $('#independiente').show();
          }
        }


        if(this.state.DataIntitucion.atentionLevel=='1'){
           this.setState({nivelatencion: 'Primer nivel'})
        }else{
          if(this.state.DataIntitucion.atentionLevel=='2'){
             this.setState({nivelatencion: 'Segundo nivel'})
          }else{
            if(this.state.DataIntitucion.atentionLevel=='3'){
               this.setState({nivelatencion: 'Tercer nivel'})
            }
          }
        }

        ese_edit=this.state.DataIntitucion.ese

        if(this.state.DataIntitucion.ese==false){
           ese='No'
       }else{
         if(this.state.DataIntitucion.ese==true){
            ese='Si'
         }
       }

       this.setState({
        form:{
         
          llave_priv:this.state.DataIntitucion.privateKey,
          llave_publi:this.state.DataIntitucion.publicKey
         
        }
      })

       if(this.state.DataMembresia.name=='MEMBRESIA PLATINIUM'){

        $('#platinium').hide();
        $('#golden').show();
        $('#diamond').hide();

        $('#platinium_in').hide();
        $('#golden_in').show();
        $('#diamond_in').hide();


       }else{

         if(this.state.DataMembresia.name=='MEMBRESIA GOLDEN'){

          $('#platinium').hide();
          $('#golden').hide();
          $('#diamond').show();

          $('#platinium_in').hide();
          $('#golden_in').hide();
          $('#diamond_in').show();

         }else{

          if(this.state.DataMembresia.name=='MEMBRESIA DIAMOND'){
            
            $('#actualiza_plan').hide();
            $('#platinium').hide();
            $('#golden').hide();
            $('#diamond').hide();

           
            $('#platinium_in').hide();
            $('#golden_in').hide();
            $('#diamond_in').hide();
  
           }else{

            $('#platinium').show();
            $('#golden').hide();
            $('#diamond').hide();

            $('#platinium_in').show();
            $('#golden_in').hide();
            $('#diamond_in').hide();

           }
         }
       }


        
      })
      .catch((error) => {
        console.log(error);
      })
    }


    seleccionardatos=()=>{

      this.Cargar_Municipios(iddepa_edit);

      this.setState({
        form:{
          nombre_edit:this.state.DataIntitucion.name,
          nombre1_edit:this.state.DataIntitucion.name1,
          nombre2_edit:this.state.DataIntitucion.name2,
          apell1_edit:this.state.DataIntitucion.lastName1,
          apell2_edit:this.state.DataIntitucion.lastName2,
          codigoprestador_edit:this.state.DataIntitucion.providerCode.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
          correo_edit:this.state.DataIntitucion.email,
          web_edit:this.state.DataIntitucion.web,
          dir_edit:this.state.DataIntitucion.address,
          tel1_edit:this.state.DataIntitucion.phone1,
          tel2_edit:this.state.DataIntitucion.phone2 ? this.state.DataIntitucion.phone2 : '',
          idrl_edit: this.state.DataIntitucion.idRepresentative,
          nom1rl_edit:this.state.DataIntitucion.nameRepresentative1 ? this.state.DataIntitucion.nameRepresentative1 : '' ,
          nom2rl_edit:this.state.DataIntitucion.nameRepresentative2 ? this.state.DataIntitucion.nameRepresentative2 : '',
          apell1rl_edit:this.state.DataIntitucion.lastNameRepresentative1 ? this.state.DataIntitucion.lastNameRepresentative1 : '',
          apell2rl_edit:this.state.DataIntitucion.lastNameRepresentative2 ? this.state.DataIntitucion.lastNameRepresentative2: '',
          tipoid_comprador_general:this.state.form.tipoid_comprador_general,
          llave_priv:this.state.form.llave_priv,
          llave_publi:this.state.form.llave_publi,
          llave_eventos:this.state.form.llave_eventos,
          llave_integridad:this.state.form.llave_integridad
         
        }
      })
      //var  dato  = solicitud.user.identification;
      //alert(dato);
    }


    subir_avatar=async()=>{
     
        
        this.setState({ loading_button_img: this.state.loading_button_img = false })
        this.setState({ active_button_img: this.state.active_button_img = false })

        let formData = new FormData();
        
        formData.append('avatar', avatar);
       

        await axios.put(ApiURL+"/api/Institutions/UploadAvatar", formData,{

          headers: {
            'Content-Type': 'multipart/form-data'            
          }

        })  
        .then(response=>{
          console.log(response.data)
          //var  mensaje  = response.data.message;
          //alert(mensaje);
          //const [text, setText] = LocalStorage(text, '')
          //setText(dato);
                 
          //window.location.href="/home";
        store.addNotification({
            title: 'Muy bien',
            message:'Su imagen de perfil ha sido cambiada',
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
            duration: 10000,
            showIcon:true
            }
          })

          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })

          $('#modal_img_perfil').modal('hide');
          this.Datos_Institucion();
          
          
        })
        .catch(error=>{
         
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            //console.log(error.response.data.message);
            //console.log(error.response.status);
            //console.log(error.response.headers);
            mensaje=error.response.data.message
            
            store.addNotification({
              title: 'Atención',
              message: 'Error al actualizar imagen',
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })

        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
            this.setState({ loading_button_img: this.state.loading_button_img = true })
            this.setState({ active_button_img: this.state.active_button_img = true })
        } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
            this.setState({ loading_button_img: this.state.loading_button_img = true })
            this.setState({ active_button_img: this.state.active_button_img = true })
        }
        //console.log(error.config);
      
      })
   
     }


     subir_portada=async()=>{
     
        
      this.setState({ loading_button_img: this.state.loading_button_img = false })
      this.setState({ active_button_img: this.state.active_button_img = false })

      let formData = new FormData();
      
      formData.append('avatar', cover);
     

      await axios.put(ApiURL+"/api/Institutions/UploadCover", formData,{

        headers: {
          'Content-Type': 'multipart/form-data'            
        }

      })  
      .then(response=>{
        console.log(response.data)
        //var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message:'Su imagen de portada ha sido cambiada',
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button_img: this.state.loading_button_img = true })
        this.setState({ active_button_img: this.state.active_button_img = true })

        $('#modal_img_portada').modal('hide');
        this.Datos_Institucion();
        
        
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: 'Error al actualizar imagen',
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

        this.setState({ loading_button_img: this.state.loading_button_img = true })
        this.setState({ active_button_img: this.state.active_button_img = true })

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })
      }
      //console.log(error.config);
    
    })
 
   }



   saveinstitution=async()=>{

    if(this.state.form.nombre_edit.length==0 ){

      store.addNotification({
        title: 'Atención',
        message: "Faltan datos de la institución... verifique!!!",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })

    }else{
      
      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })

      let formData = new FormData();
      formData.append('typeId', this.state.DataIntitucion.typeId)
      formData.append('nit', this.state.DataIntitucion.nit)
      formData.append('dv', this.state.DataIntitucion.dv)
      formData.append('name', this.state.form.nombre_edit)
      formData.append('name1', this.state.form.nombre1_edit)
      formData.append('name2', this.state.form.nombre2_edit)
      formData.append('lastname1', this.state.form.apell1_edit)
      formData.append('lastname2', this.state.form.apell2_edit)
      formData.append('Password', null)
      formData.append('providerCode', this.state.form.codigoprestador_edit)
      formData.append('email', this.state.DataIntitucion.email)  
      formData.append('web', this.state.form.web_edit)      
      formData.append('address', this.state.form.dir_edit)
      formData.append('phone1', this.state.form.tel1_edit)
      formData.append('phone2', this.state.form.tel2_edit)
      formData.append('departmentId', iddepa_edit)
      formData.append('municipalityId', idmuni_edit)
      formData.append('ProviderClass', claseprestador_edit)
      formData.append('LegalNature', naturaleza_edit)
      formData.append('Ese', ese_edit)
      formData.append('AtentionLevel', nivelatencion_edit)
      formData.append('TipeIdRepresentative', tipoidrl_edit)
      formData.append('IdRepresentative', this.state.form.idrl_edit)
      formData.append('nameRepresentative1', this.state.form.nom1rl_edit)
      formData.append('nameRepresentative2', this.state.form.nom2rl_edit)
      formData.append('lastNameRepresentative1', this.state.form.apell1rl_edit)
      formData.append('lastNameRepresentative2', this.state.form.apell2rl_edit)
      formData.append('PublicKey', "")
      formData.append('PrivateKey', "")
      formData.append('EventsKey',"")
      formData.append('Secretkey',"")

      await axios.post(ApiURL+"/api/Institutions/Save", formData,{

        headers: {
          'Content-Type': 'multipart/form-data'            
        }

      })  
      .then(response=>{
        console.log(response.data)
        var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

        this.Datos_Institucion();
        $('#modal-infoinstotucion').modal('hide'); 
        
        
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: mensaje,
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      }
      //console.log(error.config);
    
    })

    }      

   }


   save_llavesWOMPI=async()=>{

   

    if(this.state.form.llave_priv==null || this.state.form.llave_publi==null || this.state.form.llave_eventos==null || this.state.form.llave_integridad==null ){

      store.addNotification({
        title: 'Atención',
        message: "Faltan datos de las llaves por ingresar",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })

    }else{
      
      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })

      await axios.put(ApiURL+"/api/Institutions/SaveKeysWompi", 

        {
          publicKey:this.state.form.llave_publi,         
          privateKey: this.state.form.llave_priv,
          eventsKey:this.state.form.llave_eventos,
          secretKey:this.state.form.llave_integridad      
        })

      .then(response=>{
        console.log(response.data)
        var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

        this.Datos_Institucion();
        $('#modal-llaveswompi').modal('hide'); 
        
        
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: mensaje,
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      }
      //console.log(error.config);
    
    })

    }      

   }

   long_polling=async()=>{

    if(metodo_pago==='CARD'){

        axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
        .then((response) => {

          if(response.status=='200'){
    
            console.log(response.data.data.status);
    
            url_pse=response.data.data.status
    
    
            store.addNotification({
              title: 'Muy bien',
              message: 'Su compra con tarjeta de crédito ha sido: '+url_pse,
              type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

            $('#modal-compramembresia').modal('hide');
            this.setState({ loading_recurso: this.state.loading_recurso = true })
            $('#modal-loader').modal('hide') // <- to hide modal proceso compre

            this.dropmodal_comprar_membresia();

            window.location.href="/detalle_compra?id="+url; 

    
    
          }else{
              this.long_polling();  
      
            } 
        
     
        })
        .catch((error) => {
          console.log(error.message);
          //console.log(error.response.data.data);

          if(error.response.status=='417'){

            url_pse=error.response.data.message
    
    
            store.addNotification({
              title: 'Atención',
              message: url_pse,
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

            $('#modal-compramembresia').modal('hide');
            this.setState({ loading_recurso: this.state.loading_recurso = true })
            $('#modal-loader').modal('hide') // <- to hide modal proceso compre

            this.dropmodal_comprar_membresia();

            window.location.href="/detalle_compra?id="+url;

          }else{

            this.long_polling()

          }
 
          
        })

    }else{
      
            if(metodo_pago==='PSE'){
      
              axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
              .then((response) => {
      
                if(response.status=='200' && response.data.data.payment_method.extra.async_payment_url!==null){
                  
          
                  console.log(response.data.data.payment_method.extra.async_payment_url);
          
                  url_pse=response.data.data.payment_method.extra.async_payment_url

                  this.setState({ loading_recurso: this.state.loading_recurso = true })
                  $('#modal-loader').modal('hide') // <- to hide modal proceso compre
          
          
                  window.location.href=url_pse;   
          
          
                }else{
                  this.long_polling();  
          
                }         
     
              })
              .catch((error) => {
                //console.log(error.message);
               
                console.log(error.response.data.data.payment_method);
                if(error.response.data.data.payment_method.extra.async_payment_url==null){

                this.long_polling();
      
                }else{
      
                  let msj_pse=error.response.data.message
      
                  url_pse=error.response.data.data.payment_method.extra.async_payment_url
          
                  store.addNotification({
                    title: 'Atención',
                    message: msj_pse,
                    type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                  $('#modal-compramembresia').modal('hide');
                  this.setState({ loading_recurso: this.state.loading_recurso = true })
                  $('#modal-loader').modal('hide') // <- to hide modal proceso compre
      
                  this.dropmodal_comprar_membresia();
    
                  window.location.href=url_pse;
                  //window.location.href="http://app.medicall24.com.co/detalle_compra?id="+url;
                  //this.long_polling()
      
                }
      
              })

      }else{

          if(metodo_pago==='BANCOLOMBIA_TRANSFER'){
      
          axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
          .then((response) => {
  
            if(response.status=='200' && response.data.data.payment_method.extra.async_payment_url!==null){
      
              console.log(response.data.data.payment_method.extra.async_payment_url);
      
              url_pse=response.data.data.payment_method.extra.async_payment_url   
              
              this.setState({ loading_recurso: this.state.loading_recurso = true })
              $('#modal-loader').modal('hide') // <- to hide modal proceso compre
      
              window.location.href=url_pse;   
      
      
            }else{
              this.long_polling();  
      
            }         
 
          })
          .catch((error) => {
            //console.log(error.message);
            console.log(error.response.data.data.payment_method);
            if(error.response.data.data.payment_method.extra.async_payment_url==null){

              this.long_polling();
  
            }else{
  
              let msj_pse=error.response.data.message
      
              url_pse=error.response.data.data.payment_method.extra.async_payment_url
      
              store.addNotification({
                title: 'Atención',
                message: msj_pse,
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
  
              $('#modal-compramembresia').modal('hide');
              this.setState({ loading_recurso: this.state.loading_recurso = true })
              $('#modal-loader').modal('hide') // <- to hide modal proceso compre
  
              this.dropmodal_comprar_membresia();

              window.location.href=url_pse;
              //window.location.href="http://app.medicall24.com.co/detalle_compra?id="+url;
              //this.long_polling()
  
            }
  
          })

        }else{

          if(metodo_pago==='NEQUI'){
      
            axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
            .then((response) => {
    
              if(response.status=='200'){
        
                console.log(response.data.data.status);
    
                url_pse=response.data.data.status
        
        
                store.addNotification({
                  title: 'Muy bien',
                  message: 'Su compra con Nequi ha sido: '+url_pse,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                $('#modal-compramembresia').modal('hide');
                this.setState({ loading_recurso: this.state.loading_recurso = true })
                $('#modal-loader').modal('hide') // <- to hide modal proceso compre
    
                this.dropmodal_comprar_membresia(); 

                window.location.href="/detalle_compra?id="+url;
        
        
              }else{
                this.long_polling();  
        
              }         
   
            })
            .catch((error) => {
              console.log(error.message);
              
              if(error.response.status=='417'){

                url_pse=error.response.data.message
        
        
                store.addNotification({
                  title: 'Atención',
                  message: url_pse,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                $('#modal-compramembresia').modal('hide');
                this.setState({ loading_recurso: this.state.loading_recurso = true })
                $('#modal-loader').modal('hide') // <- to hide modal proceso compre
    
                this.dropmodal_comprar_membresia();

                window.location.href="/detalle_compra?id="+url;
    
              }else{
    
                this.long_polling()
    
              }
    
            })
  
          }

        }


      }

    }

    

   }

   detalle_compraXmetodo(){      
      
    this.setState({ loading_button: this.state.loading_button = false })
    this.setState({ active_button: this.state.active_button = false })

    axios.post(ApiURL+"/api/Payments/GetDetailPayment",
    {
      productID: tipo_membresia,
      PaymentMethod: metodo_pago        
    })
    .then((response) => {
      console.log(response.data);
      
      this.setState({Detalle_compra: response.data}) 

    this.setState({ loading_button: this.state.loading_button = true })
    this.setState({ active_button: this.state.active_button = true })

      $('#compra_paso2').hide();
      $('#compra_paso3').show();

      $('#btn_compra_paso2').hide();
      $('#btn_compra_paso3').show();


    })
    .catch((error) => {
      console.log(error);

      this.setState({ loading_button: this.state.loading_button = true })
      this.setState({ active_button: this.state.active_button = true })
    })
    

  }


  Validar_formularios_compra(){

          if(this.state.form.tipoid_comprador_general=='null' || this.state.form.id_comprador_general.length==0 || this.state.form.nombres_comprador_general.length==0 || this.state.form.apellidos_comprador_general.length==0 || this.state.form.dir_comprador_general.length==0 || this.state.form.tel_comprador_general.length==0){
      
            store.addNotification({
              title: 'Atención',
              message: "Faltan datos del comprador por ingresar",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })
          
          }else{
            if(metodo_pago===''){
              store.addNotification({
                title: 'Atención',
                message: "Seleccione un método de pago",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
            }
          }
          if(metodo_pago==='CARD'){
      
            if(this.state.form.num_tc.length==0 || this.state.form.tarjetahabiente.length==0 || this.state.form.mes_tc==='MM' || this.state.form.year_tc==='YY' || this.state.form.cuotas_tc==='0' || this.state.form.cod_tc.length==0){

              store.addNotification({
                title: 'Atención',
                message: "Faltan datos de la tarjeta por ingresar",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
      
            }else{
              this.detalle_compraXmetodo();
            }
      
          }else{

            if(metodo_pago==='PSE'){

              if(tipo_persona==='' || this.state.form.id_banco_pse.length==0 ){

                store.addNotification({
                  title: 'Atención',
                  message: "Faltan datos de PSE por ingresar",
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
        
              }else{
                this.detalle_compraXmetodo();
              }              

            }else{

              if(metodo_pago==='NEQUI'){

                if( this.state.form.cel_nequi.length==0 ){

                  store.addNotification({
                    title: 'Atención',
                    message: "Faltan datos de Nequi por ingresar",
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
          
                }else{
                  this.detalle_compraXmetodo();
                }

              }else{
                if(metodo_pago==='BANCOLOMBIA_TRANSFER'){

                  if( tipo_persona==='' ){

                    store.addNotification({
                      title: 'Atención',
                      message: "Faltan datos de bancolombia por ingresar",
                      type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                      container: 'top-right',                // where to position the notifications
                      animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                      animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                      dismiss: {
                        duration: 10000,
                        showIcon:true
                      }
                    })
            
                  }else{
                    this.detalle_compraXmetodo();
                  }

                }
              }
            }
            
          }

   }

   

   ComprarMembresia=async()=>{


    this.setState({ loading_button: this.state.loading_button = false })
    this.setState({ active_button: this.state.active_button = false })

    await axios.post(ApiURL+"/api/Payments/Membership",  
    {
      typeId: this.state.form.tipoid_comprador_general,
      identification: this.state.form.id_comprador_general,
      names: this.state.form.nombres_comprador_general,
      lastNames: this.state.form.apellidos_comprador_general,
      email: this.state.DataIntitucion.email,
      address: this.state.form.dir_comprador_general,
      phone: this.state.form.tel_comprador_general,
      institutionId: institution_id,
      membershipId: tipo_membresia,
      paymentMethod: {
        type: metodo_pago,
        installments: this.state.form.cuotas_tc,
        card: {
          number: this.state.form.num_tc,
          cvc: this.state.form.cod_tc,
          expMonth: this.state.form.mes_tc,
          expYear: this.state.form.year_tc,
          cardHolder: this.state.form.tarjetahabiente
        },
        userType: tipo_persona,
        paymentDescription: "Compra Membresia",
        phoneNumber: this.state.form.cel_nequi,
        userLegalIdType: this.state.form.tipoid_comprador_general,
        userLegalId: this.state.form.id_comprador_general,
        financialInstitutionCode: this.state.form.id_banco_pse
      }
    } )          

    .then(response=>{
      console.log(response.data)
      mensaje  = response.data.message;
      url  = response.data.data.transactionId;
      //alert(url);
      //const [text, setText] = LocalStorage(text, '')
      console.log(url)     
      
      if(mensaje=='No fué posible generar la transacción.'){

        store.addNotification({
          title: 'Atención',
          message: mensaje,
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

      }else{

        store.addNotification({
          title: 'Atención',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

        //window.location.href=url;
      //window.open(url)
      $('#modal-compramembresia').modal('hide');
      this.setState({ loading_recurso: this.state.loading_recurso = false })
      $('#modal-loader').modal('show') // <- to show modal descarga video

      this.setState({ loading_button: this.state.loading_button = true })
      this.setState({ active_button: this.state.active_button = true })

      this.long_polling()

      }             
      
      
      
    })
    .catch(error=>{
     
      if (error.response) {
        /*
         * The request was made and the server responded with a
         * status code that falls out of the range of 2xx
         */
        //console.log(error.response.data.message);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        mensaje=error.response.data.message
        
        store.addNotification({
          title: 'Atención',
          message: mensaje,
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })
        this.setState({ loading_recurso: this.state.loading_recurso = false })

    } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        console.log(error.request);
    } else {
        // Something happened in setting up the request and triggered an Error
        console.log('Error', error.message);
    }
    //console.log(error.config);
  
  })


   }


   Activar_membresia=async()=>{

    if(this.state.form.cod_membresia1=='' || this.state.form.cod_membresia2=='' || this.state.form.cod_membresia3=='' || this.state.form.cod_membresia4=='' || this.state.form.cod_membresia5=='' ){

      store.addNotification({
        title: 'Atención',
        message: "Ingresa un código de membresía valido",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })

    }else{
      
      
      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })    

      await axios.put(ApiURL+"/api/Memberships/AddToInstitution", 

        {           
          membershipCode: this.state.form.cod_membresia1+"-"+this.state.form.cod_membresia2+"-"+this.state.form.cod_membresia3+"-"+this.state.form.cod_membresia4+"-"+this.state.form.cod_membresia5          
        })
 
      .then(response=>{
        console.log(response.data)
        var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true }) 

        $('#modal-activarmembresia').modal('hide');

        //$('#alert-recoverypass').html('<div class="alert alert-success" role="alert">'+mensaje+'</div>');
  
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: mensaje,
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })

        //$('#alert-recoverypass').html('<div class="alert alert-danger" role="alert">'+mensaje+'</div>');

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      }
      //console.log(error.config);
    
    })
    

    }

   }

    // Sin suscripción vigente: selector de plan (pastilla) + tarjetas de precio
    // por tipo_compra/billing_period del plan seleccionado.
    render_SeleccionPlanes(){

      if (this.state.cargando_catalogo_planes===false) {
        return (
          <div className="d-flex justify-content-center">
            <ReactBootStrap.Spinner animation="border" />
          </div>
        )
      }

      const grupos = this.Planes_agrupar()
      const idsPlanes = Object.keys(grupos)

      if (!idsPlanes.length) {
        return (
          <div className="d-flex justify-content-center">
            <h6>No hay planes disponibles por el momento</h6>
          </div>
        )
      }

      const planActivoId = (this.state.planSeleccionado!==null && grupos[this.state.planSeleccionado]) ? this.state.planSeleccionado : idsPlanes[0]
      const filasPlanActivo = grupos[planActivoId] || []

      return (
        <div id="seleccion_planes">

          <div className="text-center">
            <h4>Selecciona el plan que mejor se adapte a tus necesidades</h4>
          </div>

          <div className="d-flex justify-content-center my-4">
            <div id="selector_planes_pill">
              {idsPlanes.map((idPlan)=>{
                const activo = String(idPlan)===String(planActivoId)
                return (
                  <button
                    key={idPlan}
                    type="button"
                    className={activo ? 'btn_plan_activo' : 'btn_plan_inactivo'}
                    onClick={()=> this.setState({ planSeleccionado: idPlan })}
                  >
                    {activo ? <i className="fas fa-star mr-2"></i> : null}{this.Planes_obtenerNombre(grupos[idPlan][0])}
                  </button>
                )
              })}
            </div>
          </div>

          <div className="row justify-content-center">
            {filasPlanActivo.map((fila, indice_fila)=>{

              const periodo = this.Planes_obtenerEtiquetaPeriodo(fila.billing_period)
              const precioBase = Number(fila.base_monthly_cop) || 0

              const tieneDescuentoStandard = Number(fila.standard_discount_pct) > 0
              const precioStandard = this.Planes_calcularPrecioAcsc(precioBase, fila.standard_discount_pct)

              const tieneDescuentoAcsc = Number(fila.acsc_discount_pct) > 0
              const precioAcsc = this.Planes_calcularPrecioAcsc(precioBase, fila.acsc_discount_pct)
              const ahorro = precioBase - precioAcsc

              return (
                <div className="col-md-5 col-sm-12 mb-4" key={indice_fila}>
                  <div className="card" id="tarjeta_plan_suscripcion">
                    <div className="card-body text-center">

                      <h5 id="titulo_plan">{periodo.titulo}</h5>
                      <p id="act_plan">{periodo.subtitulo}</p>

                      <div className="d-flex justify-content-center align-items-baseline flex-wrap" id="fila_precio_base">
                        {tieneDescuentoStandard ? (
                          <span className="precio_tachado mr-2">{this.Planes_formatoMoneda(precioBase)} / mes</span>
                        ) : null}
                        <h4 className="mb-0">{this.Planes_formatoMoneda(tieneDescuentoStandard ? precioStandard : precioBase)} / mes</h4>
                      </div>

                      {tieneDescuentoAcsc ? (
                      <React.Fragment>
                        <p className="mb-1">
                          Afiliados a la ACSC <span className="badge badge-acsc">Descuento -{fila.acsc_discount_pct}%</span>
                        </p>
                        <div id="precio_acsc_destacado">
                          <h3 className="mb-0" id="info">{this.Planes_formatoMoneda(precioAcsc)} / mes</h3>
                          <small>Ahorro: {this.Planes_formatoMoneda(ahorro)} / mes</small>
                        </div>
                      </React.Fragment>
                      ) : null}

                      <p className="mt-3 mb-2" id="act_plan">{periodo.facturacion}</p>

                      <a href={this.Planes_construirUrlSuscripcion(fila)} target="_blank" rel="noopener noreferrer" id="btn_suscribirme">
                        Suscribirme
                      </a>

                    </div>
                  </div>
                </div>
              )
            })}
          </div>

        </div>
      )
    }


    render(){
      const {form} = this.state;

     return (

     
      <div className="content-wrapper">

            <div className="col-12 col-sm-12 profile-page">

                  <div className="row">

                          <div className="col-sm-12">
                          <br></br>
                             <div className="text-center" id="title"> <h6> <b> PERFIL DEL PRESTADOR </b>  </h6> </div>
                          </div>
                
                         
                  </div>

                  <div className="card card-primary card-outline card-tabs">

                          <div className="card-header p-0 pt-1 border-bottom-0">
                               <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                                  <li className="nav-item">
                                    <a className="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill" href="#custom-tabs-three-home" role="tab" aria-controls="custom-tabs-three-home" aria-selected="true" > Perfil  </a>
                                  </li>
                                  
                                  <li className="nav-item">
                                    <a className="nav-link" id="custom-tabs-three-facturacion-tab" data-toggle="pill" href="#custom-tabs-three-facturacion" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="false" onClick={()=>{this.Cargar_Slug_DIAN()}} > Facturación </a>
                                  </li>
                                  <li className="nav-item">
                                    <a className="nav-link" id="custom-tabs-three-suscripcion-tab" data-toggle="pill" href="#custom-tabs-three-suscripcion" role="tab" aria-controls="custom-tabs-three-suscripcion" aria-selected="false" onClick={()=>{this.Cargar_Suscripcion()}} > Suscripción </a>
                                  </li>
                              </ul>
                            
                          </div>

                          <div className="card-body" /*id="tabla_publicaciones"*/>

                              <div className="tab-content" id="custom-tabs-three-tabContent">
                                
                                    <div className="tab-pane fade show active" id="custom-tabs-three-home" role="tabpanel" aria-labelledby="custom-tabs-three-home-tab">      

                                          <div className="cover-card">

                                              <div className="cover-card__banner">
                                                <img id="portada" className="cover-card__banner-img" alt="Portada" src={"https://medicall-api-test.azurewebsites.net/api/Files?path="+this.state.DataIntitucion.cover} />

                                                <input type="file" name="selectedFilep" id="exampleInputFilep" className="cover-card__file-input" accept="image/jpg,image/jpeg,image/bmp,image/png" onChange={this.GetImg_portada}/>
                                                <label htmlFor="exampleInputFilep" className="cover-card__edit-btn cover-card__edit-btn--cover" title="Cambiar portada">
                                                  <i className="fas fa-camera"></i> <span className="cover-card__edit-text">Editar portada</span>
                                                </label>
                                              </div>

                                              <div className="cover-card__avatar-wrap">
                                                <img id="avatar" className="cover-card__avatar" alt="Foto de perfil" src={"https://medicall-api-test.azurewebsites.net/api/Files?path="+this.state.DataIntitucion.avatar} />

                                                <input type="file" name="selectedFile" id="exampleInputFile" className="cover-card__file-input" accept="image/jpg,image/jpeg,image/bmp" onChange={this.GetImg}/>
                                                <label htmlFor="exampleInputFile" className="cover-card__edit-btn cover-card__edit-btn--avatar" title="Cambiar foto de perfil">
                                                  <i className="fas fa-camera"></i>
                                                </label>
                                              </div>

                                          </div>

                                          <hr className="profile-divider" />

                                              <div className="cover-card__info">
                                                <div className="cover-card__name-row">
                                                  <h5 className="cover-card__name">{this.state.DataIntitucion.name}</h5>
                                                  <button type="button" className="cover-card__edit-name-btn" title="Editar información" onClick={()=> this.handleModaleditinfo()}>
                                                    <i className="fas fa-pen"></i>
                                                  </button>
                                                </div>
                                              </div>
                                              <br></br>

                                          <div className="profile-info-grid">

                                              <div className="profile-info-item" id="nit_cod">
                                                <span className="profile-info-icon"><i className="fas fa-id-card"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Tipo de identificación</span>
                                                  <span className="profile-info-value">{this.state.DataIntitucion.typeId +': '+ this.state.DataIntitucion.nit +'-'+ this.state.DataIntitucion.dv}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-barcode"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Código de prestador</span>
                                                  <span className="profile-info-value">{this.state.DataIntitucion.providerCode}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-hospital"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Tipo de prestador</span>
                                                  <span className="profile-info-value">{this.state.claseprestado}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-map-marker-alt"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Dirección</span>
                                                  <span className="profile-info-value">{this.state.DataIntitucion.address +' / '+ muni +' - '+ depa}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-phone-alt"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Teléfono</span>
                                                  <span className="profile-info-value">{'+57 '+this.state.DataIntitucion.phone1}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-envelope"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Correo</span>
                                                  <span className="profile-info-value">{this.state.DataIntitucion.email}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-layer-group"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Nivel de atención</span>
                                                  <span className="profile-info-value">{this.state.nivelatencion}</span>
                                                </div>
                                              </div>

                                              <div className="profile-info-item">
                                                <span className="profile-info-icon"><i className="fas fa-globe"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">Página web</span>
                                                  {this.state.DataIntitucion.web ? (
                                                    <a href={this.state.DataIntitucion.web} target="_blank" className="profile-info-value profile-info-link">{this.state.DataIntitucion.web}</a>
                                                  ) : (
                                                    <span className="profile-info-value profile-info-value--muted">No registrada</span>
                                                  )}
                                                </div>
                                              </div>

                                              <button type="button" className="profile-info-item profile-info-item--action" onClick={()=> this.modal_llavesWOMPI()}>
                                                <span className="profile-info-icon"><i className="fas fa-key"></i></span>
                                                <div className="profile-info-text">
                                                  <span className="profile-info-label">WOMPI</span>
                                                  <span className="profile-info-value">Llaves de autenticación</span>
                                                </div>
                                              </button>

                                          </div>

                                          <br/> 

                                          {/* <div className="row justify-content-md-center">                                        
                                                          
                                              <div className="col col-lg-4">                                     

                                                  <div className="col-md-12 text-center">
                                                      <a id="btn-llaveswompi" className="btn" onClick={()=> this.modal_llavesWOMPI()}>
                                                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#AD1457" class="bi bi-key-fill" viewBox="0 0 16 16">
                                                            <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                                          </svg> Llaves de autenticación de WOMPI
                                                      </a> 
                                                  </div>
                                                          
                                              </div>                                                  
                                             
                                          </div>  */}

                                          {/* <Publicaciones/>            */}
                                      

                                    </div>

                                    

                                    <div className="tab-pane fade" id="custom-tabs-three-facturacion" role="tabpanel" aria-labelledby="custom-tabs-three-facturacion-tab">

                                        <div className="wizard-fe">

                                          <div className="wizard-fe__header">
                                            <div className="wizard-fe__title-row">
                                              <h4 className="wizard-fe__title">Facturación electrónica</h4>
                                              {this.state.Data_configuracionFE.apidianCompanyEstado ? (
                                                <span className="wizard-fe__status"><i className="fas fa-circle"></i> {this.state.Data_configuracionFE.apidianCompanyEstado}</span>
                                              ) : null}
                                            </div>
                                            <p className="wizard-fe__hint">Completa estos 3 pasos para activar la facturación electrónica de tu institución.</p>

                                            <div className="wizard-fe__steps">
                                              <button type="button" className={"wizard-fe__step" + (this.state.pasoFacturacion===1 ? " wizard-fe__step--active" : "") + (this.state.pasoFacturacion>1 ? " wizard-fe__step--done" : "")} onClick={()=> this.irPasoFacturacion(1)}>
                                                <span className="wizard-fe__step-circle">{this.state.pasoFacturacion>1 ? <i className="fas fa-check"></i> : '1'}</span>
                                                <span className="wizard-fe__step-label">Configuración</span>
                                              </button>
                                              <span className="wizard-fe__step-line"></span>
                                              <button type="button" className={"wizard-fe__step" + (this.state.pasoFacturacion===2 ? " wizard-fe__step--active" : "") + (this.state.pasoFacturacion>2 ? " wizard-fe__step--done" : "")} onClick={()=> this.irPasoFacturacion(2)}>
                                                <span className="wizard-fe__step-circle">{this.state.pasoFacturacion>2 ? <i className="fas fa-check"></i> : '2'}</span>
                                                <span className="wizard-fe__step-label">Resolución</span>
                                              </button>
                                              <span className="wizard-fe__step-line"></span>
                                              <button type="button" className={"wizard-fe__step" + (this.state.pasoFacturacion===3 ? " wizard-fe__step--active" : "")} onClick={()=> this.irPasoFacturacion(3)}>
                                                <span className="wizard-fe__step-circle">3</span>
                                                <span className="wizard-fe__step-label">Certificado</span>
                                              </button>
                                            </div>
                                          </div>

                                          <div className="wizard-fe__body">

                                            {this.state.pasoFacturacion===1 ? (
                                              <React.Fragment>
                                                <h5 className="wizard-fe__step-title">Credenciales DIAN</h5>
                                                <p className="wizard-fe__step-desc">Datos del software y ambiente autorizados por la DIAN para tu institución.</p>

                                                <div className="wizard-fe__grid">

                                                  <div className="wizard-fe__field">
                                                    <label>ID Software</label>
                                                    <div className="input-group">
                                                      <input type="text" maxLength="50" className="form-control" name="softwareId" onChange={this.handleChange} value={this.state.form.softwareId}/>
                                                      <div className="input-group-append">
                                                        <button type="button" className="wizard-fe__field-help" data-toggle="tooltip" data-placement="top" title="Identificador del software autorizado por la DIAN"><span className="fas fa-info-circle"></span></button>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Software Pin</label>
                                                    <div className="input-group">
                                                      <input type="text" maxLength="50" className="form-control" name="softwarePin" onChange={this.handleChange} value={this.state.form.softwarePin}/>
                                                      <div className="input-group-append">
                                                        <button type="button" className="wizard-fe__field-help" data-toggle="tooltip" data-placement="top" title="PIN de seguridad asociado al software autorizado"><span className="fas fa-info-circle"></span></button>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Ambiente</label>
                                                    <select onChange={this.GetAmbienteDIAN} className="form-control" id="ambiente_dian" name="ambiente_dian" value={this.state.form.ambiente}>
                                                      <option value="0">Seleccione...</option>
                                                      {this.state.Slug_ambientes.map(ambiente=> <option key={ambiente.id} value={ambiente.id}>{ambiente.name}</option>)}
                                                    </select>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>TestSetId</label>
                                                    <div className="input-group">
                                                      <input type="text" maxLength="50" className="form-control" name="testSetId" onChange={this.handleChange} value={this.state.form.testSetId}/>
                                                      <div className="input-group-append">
                                                        <button type="button" className="wizard-fe__field-help" data-toggle="tooltip" data-placement="top" title="Identificador de las pruebas de habilitación ante la DIAN"><span className="fas fa-info-circle"></span></button>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Registro mercantil</label>
                                                    <div className="input-group">
                                                      <input type="text" maxLength="50" className="form-control" name="merchantRegistration" onChange={this.handleChange} value={this.state.form.merchantRegistration}/>
                                                      <div className="input-group-append">
                                                        <button type="button" className="wizard-fe__field-help" data-toggle="tooltip" data-placement="top" title="Número de registro mercantil de la institución"><span className="fas fa-info-circle"></span></button>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Régimen</label>
                                                    <select onChange={this.GetRegimenDIAN} className="form-control" id="regimen_dian" name="regimen_dian" value={this.state.form.typeRegimeId}>
                                                      <option value="0">Seleccione...</option>
                                                      {this.state.Slug_regimenes.map(regimen=> <option key={regimen.id} value={regimen.id}>{regimen.name}</option>)}
                                                    </select>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Tipo de responsabilidad</label>
                                                    <select onChange={this.GetresponsabilidadDIAN} className="form-control" id="responsabilidad_dian" name="responsabilidad_dian" value={this.state.form.typeLiabilityId}>
                                                      <option value="0">Seleccione...</option>
                                                      {this.state.Slug_responsabilidades.map(responsabilidad=> <option key={responsabilidad.id} value={responsabilidad.id}>{responsabilidad.name}</option>)}
                                                    </select>
                                                  </div>

                                                </div>
                                              </React.Fragment>
                                            ) : null}

                                            {this.state.pasoFacturacion===2 ? (
                                              <React.Fragment>
                                                <h5 className="wizard-fe__step-title">Resolución de facturación</h5>
                                                <p className="wizard-fe__step-desc">Información de la resolución de numeración vigente emitida por la DIAN.</p>

                                                <div className="wizard-fe__grid">

                                                  <div className="wizard-fe__field">
                                                    <label>Tipo de documento</label>
                                                    <input type="text" maxLength="50" className="form-control" name="tipo_factura" onChange={this.handleChange} value={this.state.form.tipo_factura}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Tipo de documento (DIAN)</label>
                                                    <select onChange={this.handleChange} className="form-control" id="tipodocumento_dian" name="tipodocumento_dian" value={this.state.form.tipodocumento_dian}>
                                                      <option value="0">Seleccione...</option>
                                                      {this.state.Slug_tipodocumento.map(tipodocumento=> <option key={tipodocumento.id} value={tipodocumento.id}>{tipodocumento.name}</option>)}
                                                    </select>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Número de resolución</label>
                                                    <input type="text" maxLength="50" className="form-control" name="num_resolucion" onChange={this.handleChange} value={this.state.form.num_resolucion}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Fecha de resolución</label>
                                                    <input type="date" className="form-control" name="fecha_resolucion" id="fecha_resolucion" onChange={this.handleChange} value={this.state.form.fecha_resolucion}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Prefijo</label>
                                                    <input type="text" maxLength="50" className="form-control" name="prefijo" onChange={this.handleChange} value={this.state.form.prefijo}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Rango desde</label>
                                                    <input type="text" maxLength="50" className="form-control" name="rango_desde" id="rango_desde" onChange={this.handleChange} value={this.state.form.rango_desde}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Rango hasta</label>
                                                    <input type="text" maxLength="50" className="form-control" name="rango_hasta" id="rango_hasta" onChange={this.handleChange} value={this.state.form.rango_hasta}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Clave técnica</label>
                                                    <input type="text" maxLength="50" className="form-control" name="claveTecnica" onChange={this.handleChange} value={this.state.form.claveTecnica}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Fecha inicio</label>
                                                    <input type="date" className="form-control" name="fechainicio_resolucion" onChange={this.handleChange} value={this.state.form.fechainicio_resolucion}/>
                                                  </div>

                                                  <div className="wizard-fe__field">
                                                    <label>Fecha vencimiento</label>
                                                    <input type="date" className="form-control" name="fechavencimiento_resolucion" onChange={this.handleChange} value={this.state.form.fechavencimiento_resolucion}/>
                                                  </div>

                                                </div>
                                              </React.Fragment>
                                            ) : null}

                                            {this.state.pasoFacturacion===3 ? (
                                              <React.Fragment>
                                                <h5 className="wizard-fe__step-title">Certificado digital</h5>
                                                <p className="wizard-fe__step-desc">Certificado con el que se firmarán electrónicamente tus facturas.</p>

                                                <div className="wizard-fe__grid">
                                                  <div className="wizard-fe__field">
                                                    <label>Clave certificado</label>
                                                    <input type="text" maxLength="50" className="form-control" name="claveCertificado" onChange={this.handleChange} value={this.state.form.claveCertificado}/>
                                                  </div>
                                                </div>

                                                <div className="wizard-fe__p12">
                                                  <div className="wizard-fe__p12-text">
                                                    <label>Certificado digital (.p12)</label>
                                                    <p className="wizard-fe__p12-hint">Selecciona tu archivo .p12 y lo convertimos automáticamente a Base64 en el campo de abajo.</p>
                                                    {this.state.form.certificadoP12Nombre ? (
                                                      <span className="wizard-fe__p12-file"><i className="fas fa-certificate"></i> {this.state.form.certificadoP12Nombre}</span>
                                                    ) : null}
                                                  </div>
                                                  <input type="file" accept=".p12" id="input_certificado_p12" className="wizard-fe__p12-input" onChange={this.ConvertirCertificadoP12Base64}/>
                                                  <label htmlFor="input_certificado_p12" className="wizard-fe__btn wizard-fe__btn--primary wizard-fe__p12-btn">
                                                    <i className="fas fa-file-upload"></i> Convertir a Base64
                                                  </label>
                                                </div>

                                                <div className="wizard-fe__field wizard-fe__field--full">
                                                  <div className="wizard-fe__field-label-row">
                                                    <label>Firma Base64</label>
                                                    {this.state.form.firma_cer_base64 ? (
                                                      <button type="button" className="wizard-fe__clear-btn" onClick={()=> this.LimpiarFirmaBase64()}>
                                                        <i className="fas fa-times"></i> Limpiar
                                                      </button>
                                                    ) : null}
                                                  </div>
                                                  <textarea className="form-control" rows="6" name="firma_cer_base64" onChange={this.handleChange} value={this.state.form.firma_cer_base64}></textarea>
                                                </div>
                                              </React.Fragment>
                                            ) : null}

                                          </div>

                                          <div className="wizard-fe__footer">
                                            <button type="button" className="wizard-fe__btn wizard-fe__btn--ghost" disabled={this.state.pasoFacturacion===1} onClick={()=> this.irPasoFacturacion(this.state.pasoFacturacion-1)}>
                                              <i className="fas fa-arrow-left"></i> Atrás
                                            </button>

                                            <div className="wizard-fe__footer-primary">

                                              {this.state.pasoFacturacion===1 ? (
                                                <button type="button" className="wizard-fe__btn wizard-fe__btn--primary" disabled={!this.state.active_button} onClick={()=> this.Guardar_configuracionFE()}>
                                                  {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar configuración
                                                </button>
                                              ) : null}

                                              {this.state.pasoFacturacion===2 ? (
                                                <button type="button" className="wizard-fe__btn wizard-fe__btn--primary" onClick={()=> this.Guardar_resolucionFE_pendiente()}>
                                                  Guardar resolución
                                                </button>
                                              ) : null}

                                              {this.state.pasoFacturacion===3 ? (
                                                <button type="button" className="wizard-fe__btn wizard-fe__btn--primary" onClick={()=> this.Guardar_certificadoFE_pendiente()}>
                                                  Guardar certificado
                                                </button>
                                              ) : null}

                                              {this.state.pasoFacturacion<3 ? (
                                                <button type="button" className="wizard-fe__btn wizard-fe__btn--next" onClick={()=> this.irPasoFacturacion(this.state.pasoFacturacion+1)}>
                                                  Siguiente <i className="fas fa-arrow-right"></i>
                                                </button>
                                              ) : null}

                                            </div>
                                          </div>

                                        </div>

                                    </div>

                                    <div className="tab-pane fade" id="custom-tabs-three-suscripcion" role="tabpanel" aria-labelledby="custom-tabs-three-suscripcion-tab">

                                        {this.state.cargando_suscripcion?(
                                        <React.Fragment>

                                        {this.state.Suscripcion_vigente ? (
                                          <div className="row">
                                            <div className="col-md-12">
                                              <div className="card" id="tarjeta_suscripcion_vigente">
                                                <div className="card-body">
                                                  <div className="d-flex justify-content-between align-items-start flex-wrap">
                                                    <div>
                                                      <span className="badge badge-success">Suscripción activa</span>
                                                      <h4 className="mt-2 mb-1" id="titulo_plan">{this.Suscripcion_obtenerPlan(this.state.Suscripcion_vigente)}</h4>
                                                      <p className="mb-0" id="act_plan">
                                                        {this.Suscripcion_obtenerInicio(this.state.Suscripcion_vigente) ? (
                                                          <React.Fragment>Vigente desde <Moment format="YYYY/MM/DD">{this.Suscripcion_obtenerInicio(this.state.Suscripcion_vigente)}</Moment></React.Fragment>
                                                        ) : null}
                                                        {this.Suscripcion_obtenerFin(this.state.Suscripcion_vigente) ? (
                                                          <React.Fragment> hasta <Moment format="YYYY/MM/DD">{this.Suscripcion_obtenerFin(this.state.Suscripcion_vigente)}</Moment></React.Fragment>
                                                        ) : null}
                                                      </p>
                                                      {(this.state.Suscripcion_vigente.billing_period || this.state.Suscripcion_vigente.tipo_compra) ? (
                                                      <p className="mb-0" id="act_plan">
                                                        {this.state.Suscripcion_vigente.billing_period ? (
                                                          <React.Fragment>Periodo de facturación: {this.Suscripcion_traducirPeriodoFacturacion(this.state.Suscripcion_vigente.billing_period)}</React.Fragment>
                                                        ) : null}
                                                        {this.state.Suscripcion_vigente.billing_period && this.state.Suscripcion_vigente.tipo_compra ? ' · ' : null}
                                                        {this.state.Suscripcion_vigente.tipo_compra ? (
                                                          <React.Fragment>Tipo de compra: {this.Suscripcion_traducirTipoCompra(this.state.Suscripcion_vigente.tipo_compra)}</React.Fragment>
                                                        ) : null}
                                                      </p>
                                                      ) : null}
                                                    </div>
                                                    <div className="text-right">
                                                      <h3 id="info">{this.Suscripcion_formatoMoneda(this.Suscripcion_obtenerValor(this.state.Suscripcion_vigente))}</h3>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="row">
                                            <div className="col-md-12">
                                              {this.render_SeleccionPlanes()}
                                            </div>
                                          </div>
                                        )}

                                        <div className="row">
                                          <div className="col-sm-12">
                                          <br></br>
                                             <div className="text-center" id="title"> <h6> <b> HISTORIAL DE SUSCRIPCIONES </b>  </h6> </div>
                                          </div>
                                        </div>

                                        {this.state.Suscripciones.length ? (
                                        <div className="card table-responsive">
                                            <table id="tabla_suscripciones" className="table table-bordered table-striped table-hover">
                                                <thead>
                                                  <tr>
                                                    <th>Plan</th>
                                                    <th>Fecha inicio</th>
                                                    <th>Fecha fin</th>
                                                    <th>Valor</th>
                                                    <th>Estado</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {this.state.Suscripciones.map((suscripcion, indice_suscripcion)=>{

                                                    var estado_suscripcion = this.Suscripcion_resolverEstadoVisual(suscripcion)
                                                    var es_vigente_suscripcion = this.Suscripcion_esVigente(suscripcion)
                                                    var inicio_suscripcion = this.Suscripcion_obtenerInicio(suscripcion)
                                                    var fin_suscripcion = this.Suscripcion_obtenerFin(suscripcion)

                                                    return(
                                                    <tr key={indice_suscripcion} className={es_vigente_suscripcion ? 'fila_suscripcion_activa' : ''}>
                                                      <td>{this.Suscripcion_obtenerPlan(suscripcion)}</td>
                                                      <td>{inicio_suscripcion ? <Moment format="YYYY/MM/DD">{inicio_suscripcion}</Moment> : '-'}</td>
                                                      <td>{fin_suscripcion ? <Moment format="YYYY/MM/DD">{fin_suscripcion}</Moment> : '-'}</td>
                                                      <td>{this.Suscripcion_formatoMoneda(this.Suscripcion_obtenerValor(suscripcion))}</td>
                                                      <td><span className={`badge ${estado_suscripcion.claseBadge}`}>{estado_suscripcion.texto}</span></td>
                                                    </tr>
                                                    )
                                                  })}
                                                </tbody>
                                            </table>
                                        </div>
                                        ):(
                                        <div className="d-flex justify-content-center">
                                          <h6>No hay suscripciones registradas</h6>
                                        </div>
                                        )}

                                        <div className="row">
                                          <div className="col-sm-12" style={{position:'relative'}}>
                                          <br></br>
                                             <div className="text-center" id="title"> <h6> <b> MÉTODOS DE PAGO </b>  </h6> </div>
                                             <button type="button" className="btn btn-primary btn-sm" style={{position:'absolute', right:15, top:15}} onClick={()=>{ this.modal_metodospago() }}>
                                              Gestión de métodos de pago
                                            </button>
                                          </div>
                                        </div>

                                        <div className="modal fade" id="modal-metodospago">
                                            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                                              <div className="modal-content">
                                                <div className="modal-header">
                                                  <h4 className="modal-title"><b>Gestionar mis métodos de pago</b></h4>
                                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                  </button>
                                                </div>
                                                <div className="modal-body" style={{padding:0}}>
                                                  <iframe
                                                    src={"https://appmedicall24.com/ecosistema-medico-360/metodos-pago?id="+identi_profe}
                                                    title="Métodos de pago"
                                                    style={{width:'100%', minHeight:'640px', border:0, background:'transparent'}}
                                                  ></iframe>
                                                </div>
                                              </div>
                                            </div>
                                        </div>

                                        {this.state.MetodoPago ? (
                                        <div className="card table-responsive">
                                            <table id="tabla_metodospago" className="table table-bordered table-striped table-hover">
                                                <thead>
                                                  <tr>
                                                    <th>ID</th>
                                                    <th>Nombre en la tarjeta</th>
                                                    <th>Tarjeta</th>
                                                    <th>Tarjeta principal</th>
                                                    <th>Fecha de inscripción</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr className={this.state.MetodoPago.es_principal ? 'fila_suscripcion_activa' : ''}>
                                                    <td>{this.state.MetodoPago.id}</td>
                                                    <td>{this.state.MetodoPago.titular_tarjeta}</td>
                                                    <td>{this.MetodoPago_formatoTarjeta(this.state.MetodoPago.tarjeta_ultimos_4)}</td>
                                                    <td>{this.state.MetodoPago.es_principal ? <span className="badge badge-success">Principal</span> : <span className="text-muted">—</span>}</td>
                                                    <td>{this.state.MetodoPago.created_at ? <Moment format="YYYY/MM/DD">{this.state.MetodoPago.created_at}</Moment> : '-'}</td>
                                                  </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        ):(
                                        <div className="d-flex justify-content-center">
                                          <h6>No hay métodos de pago registrados</h6>
                                        </div>
                                        )}

                                        </React.Fragment>
                                        ):(
                                        <div className="d-flex justify-content-center">
                                            <ReactBootStrap.Spinner animation="border" />
                                        </div>
                                        )}

                                    </div>

                              </div>

                          </div>


                  </div>

            </div>



            <div className="modal fade" id="modal_img_perfil">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title"><b>Imagen de perfil</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
    
                    <div className="modal-body">
                        
                          <div className="row"> <br/>

                              <img src={files_view} id="act_avatar" alt="logo" width= "440" className="rounded-circle"/>
                                                  
                          
                          </div>

                    </div> 
    
                    <div className="modal-footer justify-content-between">      
                                                        
                          <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.subir_avatar()}>{this.state.loading_button_img?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Guardar</button>            
                          <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.drop_view_img}>Cerrar</button>
                             
                    </div>

                  </div>                  
                </div>                
              </div> 


              <div className="modal fade" id="modal_img_portada">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title"><b>Imagen de portada</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
    
                    <div className="modal-body">
                        
                          <div className="row"> <br/>
                               
                              <img src={files_viewp} alt="logo" width= "750" className="rounded"/>
                                                  
                          
                          </div>

                    </div> 
    
                    <div className="modal-footer justify-content-between">      
                                                        
                          <button type="button" className="btn btn-primary" disabled={!this.state.active_button}  onClick={()=> this.subir_portada()}>{this.state.loading_button_img?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Guardar</button>
                          <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.drop_view_img}>Cerrar</button>
                             
                    </div>

                  </div>                  
                </div>                
              </div> 



              <div className="modal fade" id="modal-infoinstotucion">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title"><b>Editar información de la institución</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>

                      <div className="modal-body">
    
                            <div className="row">
                
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Nombre prestador:</label>
                                          <input type="text" className="form-control" name="nombre_edit" value={form.nombre_edit} onChange={this.handleChange} />                      
                                        </div>                 
                                  </div>

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Nit:</label>
                                          <input type="text" className="form-control"  name="codigoprestador_edit" value={this.state.DataIntitucion.nit+"-"+this.state.DataIntitucion.dv} readOnly />                      
                                        </div>                 
                                  </div> 
    
                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Código prestador:</label>
                                          <input type="text" maxLength="12" className="form-control camponum"  name="codigoprestador_edit" onChange={this.handleChange} onKeyDown={this.Campo_numerico()} value={form.codigoprestador_edit} />                      
                                        </div>                 
                                  </div>                          
                
                            </div>
                        
                            <div className="row">
                
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Dirección:</label>
                                          <input type="text" className="form-control" name="dir_edit" value={form.dir_edit} onChange={this.handleChange}/>                      
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Telefono 1:</label>
                                          <input type="text" maxLength="15" className="form-control camponum" name="tel1_edit" value={form.tel1_edit} onChange={this.handleChange}/>                      
                                        </div>                 
                                  </div>

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Telefono 2:</label>
                                          <input type="text" maxLength="15" className="form-control camponum" name="tel2_edit" value={form.tel2_edit} onChange={this.handleChange}/>                      
                                        </div>                 
                                  </div>                  
                
                            </div>
                
                            <div className="row">
                
                                  <div className="col-md-6">              
                                      <div className="form-group">                    
                                              <label >Pagina web:</label>
                                              <input type="text" className="form-control" name="web_edit" value={form.web_edit} onChange={this.handleChange}/>
                                      </div>              
                                  </div>
                                                    
                                  <div className="col-md-3">                
                                        <div className="form-group">                    
                                            <label >Departamento:</label>
                                            <select onChange={this.GetDepartamento}  className="form-control">
                                               <option id="cb_departamento" value={iddepa_edit}>{depa}</option>  
                                               {this.state.Departamentos.map(item=>                              
                                               <option key={item.id} value={item.id}> {item.nombre.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                               )}                                                                                  
                                            </select>                                                                 
                                        </div>                                             
                                  </div>

                                  <div className="col-md-3">                
                                        <div className="form-group">                    
                                            <label >Municipio:</label>
                                            <select onChange={this.GetMunicipio}  className="form-control">
                                               {/* <option id="cb_municipio_seleccione"  value="0">Seleccione...</option> */}
                                               <option id="cb_municipio"  value={idmuni_edit}>{muni}</option>  
                                               {this.state.Municipios.map(item=>                              
                                                <option key={item.id} value={item.id}> {(item.nombre).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                                )}                                                                                  
                                            </select>                                                                 
                                        </div>                                             
                                  </div>
                
                            </div>

                            <div className="row">
                
                                  <div className="col-md-3">                
                                        <div className="form-group">                    
                                            <label >Clase de prestador:</label>
                                            <select onChange={this.GetClasepres} onClick={this.GetClasepres}  className="form-control">
                                                  <option id="cb_claseprestador" value={claseprestador_edit}>{this.state.claseprestado}</option>  
                                                  <option  value="ips">Instituciones - IPS</option> 
                                                  <option  value="profesional independiente">Profesional independiente</option>
                                                  <option  value="transporte Especial de Pacientes">Transporte Especial de Pacientes</option>
                                                                                                                               
                                            </select>                                                                 
                                        </div>                                             
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Naturaleza jurídica:</label>
                                          <select onChange={this.GetTipoNatu} onClick={this.GetTipoNatu}  className="form-control">
                                                <option id="cb_naturaleza" value={naturaleza_edit}>{(naturaleza_edit).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                                <option  value="privada">Privada</option> 
                                                <option  value="publica">Pública</option>
                                                <option  value="mixta">Mixta</option>                                                                               
                                          </select>
                                        </div>                 
                                  </div>

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Nivel de atención:</label>
                                          <select onChange={this.GetNivel} onClick={this.GetNivel}  className="form-control">
                                                <option id="cb_nivel" value={nivelatencion_edit}>{nivelatencion_edit}</option>  
                                                <option  value="1">1</option>
                                                <option  value="2">2</option> 
                                                <option  value="3">3</option>                                                                               
                                          </select>
                                        </div>                 
                                  </div>   

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Empresa social del estado:</label>
                                          <select onChange={this.GetESE} onClick={this.GetESE}  className="form-control">
                                                <option id="cb_ese" value={this.state.DataIntitucion.ese}>{ese}</option>  
                                                <option  value="false">No</option>
                                                <option  value="true">Si</option>                                                                               
                                          </select>
                                        </div>                 
                                  </div>               
                
                            </div>

                            <b>Datos del representante legal:</b>
                            <br/><br/>

                            <div className="row"> 
                
                                  <div className="col-md-6">                
                                        <div className="form-group">                    
                                            <label >Tipo ID:</label>
                                            <select onChange={this.GetTipoIDLD} onClick={this.GetTipoIDLD}  className="form-control">
                                                  <option id="cb_tipoid_rl" value={tipoidrl_edit}>{tipoidrl_edit}</option> 
                                                  <option  value="CC">Cédula de ciudadania</option> 
                                                  <option  value="CE">Cédula de extrangeria</option>  
                                                                                                                               
                                            </select>                                                                 
                                        </div>                                             
                                  </div> 

                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Numero ID:</label>
                                          <input type="text" maxLength="10" className="form-control camponum" name="idrl_edit" value={form.idrl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div>       
                
                            </div>

                            <div className="row">                      

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Primer nombre:</label>
                                          <input type="text" className="form-control" name="nom1rl_edit" value={form.nom1rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Segundo nombre legal:</label>
                                          <input type="text" className="form-control" name="nom2rl_edit" value={form.nom2rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Primer apellido:</label>
                                          <input type="text" className="form-control" name="apell1rl_edit" value={form.apell1rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Segundo apellido:</label>
                                          <input type="text" className="form-control" name="apell2rl_edit" value={form.apell2rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div>             
                
                            </div>                
                
                      </div>
                
                      <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.saveinstitution()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar</button>
                        <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>        
                      </div>
                    </div>
                    
                  </div>
              
              </div> 


              <div className="modal fade" id="modal-activarmembresia">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="col-11 modal-title text-center" id="correo_activacion"><b>Activar membresía</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
    
                    <div className="modal-body">                       

                          <div className="row">                           
                                          
                              <div className="col-md-12">
                                  <div className="form-group"> 

                                          <label >Ingresa el código de la membresía:</label>
                                      
                                  </div>          
                              </div>

                          </div> 

                          <div className="row justify-content-md-center"> <br/>                                      
                              
                                 
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia1" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia2" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia3" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia4" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia5" id="cod_membresia" onChange={this.handleChange}/>
                              
                             
              
                          </div>

                          <div className="col-md-12 text-center"> <br/>
                                  <button type="submit" id="btn-activacuenta" className="btn"  disabled={!this.state.active_button} onClick={()=> this.Activar_membresia()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Activar</button>                     
                          </div>
    
                              
                    </div> 
    
                  </div>
                  
                </div>
                
              </div>


              <div className="modal fade" id="modal-llaveswompi" data-backdrop="static">

                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header" id="fondo_modal_compra">
                      <h4 className="col-11 modal-title text-center" id="correo_activacion"><b>Llaves asociadas a Wompi</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=> this.Datos_Institucion()}>
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
  
                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Llave pública</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_publi" autoComplete='nope' value={form.llave_publi} onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde a la llave pública asignada por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Llave privada</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_priv" autoComplete='nope' value={form.llave_priv}  onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde a la llave privada asignada por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Eventos</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_eventos"  onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde al secreto eventos asignado por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Integridad</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_integridad"  onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde al secreto integridad asignado por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <p type="button" class="btn btn-secondary" id="campos_obligatorios"><b id="asterisco">*</b> <a id="btn-registrarse" href="https://comercios.wompi.co/developers" target="_blank"> Para mas información ingresa a: https://comercios.wompi.co/developers </a> </p>
                                 
                    </div>
          
                          <div className="modal-footer justify-content-between">        
                             <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.save_llavesWOMPI()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Registrar</button>
                             <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.Datos_Institucion()}>Cerrar</button>
                          </div>
                  </div>                
                </div>
            
              </div>


              <div className="modal fade" id="modal-compramembresia">

                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header" id="fondo_modal_compra">
                        <h4 className="col-11 modal-title text-center"><b>{this.state.Detalle_membresia.name}</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>                       
                      </div>    
    
                      <form>                               

                          <div className="modal-body">
                              
                              <div id="compra_paso1">


                                      <div className="d-flex justify-content-center">              
                                                                                                 
                                            <img src={paso1} />                                                             
                                
                                      </div>

                                       
                                      <br/> 

                                      <div className="row justify-content-md-center">

                                            <div className="col-lg-12">

                                                <div className="card" id="card_body">
                                                      <div className="card-header text-center">
                                                         <b>Detalle del producto</b> <br/>
                                                      </div>
                                                      <div className="card-body">
                                                          <div className="row d-flex justify-content-center">
                                                       
                                                              <div className="col col-lg-5 text-right">                                                                      
                                                                 
                                                                  <b>Subtotal: $</b> <br/>
                                                                  <b>IVA: $</b> <br/>
                                                                  <b>Total: $</b> <br/>


                                                              </div> 
                                                              <div className="col-sm-6">                                                                      
                                                                 
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_membresia.priceCOP))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_membresia.percentIVA))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_membresia.priceCOP))}</b> <br/>


                                                              </div>          
    
                                                          </div>
                                                      </div>
                                                </div>
            
                                            </div>
                                  
                                      </div>
                                      
                                      <div className="row justify-content-md-center">

                                          <div className="col-md-5">                
                                                <div className="form-group">                    
                                                    <label > <h5>Datos del comprador</h5></label>
                                                                                                                 
                                                </div>                                             
                                          </div> 
                                  
                                      </div>  

                                      <div className="row">

                                            <div className="col-md-6">
                                                  <div className="form-group"> 

                                                        <label >Tipo ID</label>
                                                        <select  className="form-control" name="tipoid_comprador_general" id="tipoid_comprador_general" onChange={this.handleChange}  required>                                                          
                                                           <option  value="null">Seleccione...</option> 
                                                           <option  value="CC">Cédula de ciudadania</option> 
                                                           <option  value="CE">Cédula de extrangeria</option>
                                                           <option  value="NIT">NIT</option>                    
                                                        </select>
                                                                            
                                                  </div>                 
                                            </div> 
                          
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Identificación</label>
                                                    <input type="text" className="form-control" name="id_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>
              
                                      </div> 
        
                                      <div className="row">
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Nombres</label>
                                                    <input type="text" className="form-control" name="nombres_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div> 
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Apellidos</label>
                                                    <input type="text" className="form-control" name="apellidos_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                         
                          
                                      </div>
                            
                                      <div className="row">
                          
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Enviaremos el código de activación a este correo</label>
                                                    <input type="email" className="form-control" name="correo_comprador_general" onChange={this.handleChange} value={this.state.DataIntitucion.email} readOnly/>                      
                                                  </div>                 
                                            </div>                   
                          
                                      </div>
                    
                                      <div className="row">
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Dirección</label>
                                                    <input type="text" className="form-control" name="dir_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div> 
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Telefono</label>
                                                    <input type="text" className="form-control" name="tel_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                         
                          
                                      </div>
                              </div>

                              <div id="compra_paso2">

                                <div className="row">                                      
                                                                                           
                                      <img src={paso2} />                                                                
                          
                                </div>

                                <br/> 

                                <div className="row justify-content-md-center">

                                      <div className="col-md-7">                
                                            <div className="form-group">                    
                                                <label > <h5>Seleccione un método de pago</h5></label>
                                                                                                             
                                            </div>                                             
                                      </div> 
                                  
                                </div>  
                                            
                                <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="CARD" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios1">  Tarjeta de crédito  </label>
                                            <div className="input-group-append">
                                                  <img src={card_credit} />
                                            </div>
                                      </div>                                                        
                                           
                                </div> 

                                <br/>

                                <div className="row justify-content-md-center" id="tarjeta_credito">

                                    <div className="col-sm-12">
                                      

                                      <div className="row">
              
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Número completo de la tarjeta (sin espacios)</label>
                                                    <input type="text" className="form-control" name="num_tc" placeholder="4400330022001100" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                        
                          
                                      </div>

                                      <div className="row">
              
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Nombre en la tarjeta</label>
                                                    <input type="text" className="form-control" maxLength="30" name="tarjetahabiente" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                        
                          
                                      </div>

                                      <div className="row">
              
                                            <div className="col-md-4">
                                                  <div className="form-group"> 

                                                        <label >Fecha de expiración</label>
                                                        <div className="input-group">

                                                              <div className="input-group-append">
      
                                                                    <select  onChange={this.handleChange}  className="form-control" name="mes_tc" id="mes_tc" >                                                          
                                                                       <option  value="MM">MM</option>
                                                                       <option  value="01">01</option> 
                                                                       <option  value="02">02</option>
                                                                       <option  value="03">03</option>
                                                                       <option  value="04">04</option> 
                                                                       <option  value="05">05</option>
                                                                       <option  value="06">06</option>  
                                                                       <option  value="07">07</option> 
                                                                       <option  value="08">08</option>
                                                                       <option  value="09">09</option>  
                                                                       <option  value="10">10</option> 
                                                                       <option  value="11">11</option>
                                                                       <option  value="12">12</option>                      
                                                                    </select>
      
                                                              </div>

                                                              <div className="input-group-append">
      
                                                                    <select  onChange={this.handleChange}  className="form-control" name="year_tc" id="year_tc" >                                                          
                                                                       <option  value="YY">YY</option>                                                                       
                                                                       <option  value="23">23</option> 
                                                                       <option  value="24">24</option> 
                                                                       <option  value="25">25</option>
                                                                       <option  value="26">26</option>
                                                                       <option  value="27">27</option> 
                                                                       <option  value="28">28</option>
                                                                       <option  value="29">29</option>
                                                                       <option  value="30">30</option> 
                                                                       <option  value="31">31</option>
                                                                       <option  value="32">32</option>                                                                            
                                                                    </select>
      
                                                              </div>
                                                        </div>                                                    
                                                                            
                                                  </div>                 
                                            </div> 

                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                        <label >Cuotas</label>
                                                        <select  onChange={this.handleChange} className="form-control" name="cuotas_tc"  id="cuotas_tc">                                                         
                                                           <option  value="1">1</option> 
                                                           <option  value="2">2</option> 
                                                           <option  value="3">3</option> 
                                                           <option  value="4">4</option>
                                                           <option  value="5">5</option> 
                                                           <option  value="6">6</option>
                                                           <option  value="7">7</option> 
                                                           <option  value="8">8</option>  
                                                           <option  value="9">9</option> 
                                                           <option  value="10">10</option>
                                                           <option  value="11">11</option> 
                                                           <option  value="12">12</option>                                                                     
                                                        </select>
                                                                              
                                                     </div>                 
                                            </div>

                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                    <label >Código de seguridad</label>
                                                    <input type="text" maxLength="3" className="form-control" name="cod_tc" placeholder="000" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div> 

                                      </div>

                                      <hr></hr>

                                    </div>

                                </div>

                                                      
                                <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="PSE" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios2">  PSE  </label>
                                            <div className="input-group-append">
                                                  <img src={pse} />
                                            </div>
                                      </div>                                                        
                                           
                                </div> 

                                <br/>  

                                <div className="row justify-content-md-center" id="pse">

                                    <div className="col-sm-12">

                                      {/* <div className="row">              
                                           
              
                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                        <label >Tipo de documento</label>
                                                        <select onChange={this.handleChange} className="form-control" name="tipodcto_pse"  className="form-control">                                                         
                                                           <option  value="CC">CC</option> 
                                                           <option  value="NIT">NIT</option>                                                                        
                                                        </select>
                                                                              
                                                     </div>                 
                                            </div>  

                                            <div className="col-md-8">
                                                  <div className="form-group">                    
                                                    <label >Número de documento</label>
                                                    <input type="text" maxLength="10" className="form-control" name="numerodcto_pse"  onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                      
                          
                                      </div> */}


                                      <div className="row">

                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                        <label >Tipo de persona</label>
                                                        <select onChange={this.GetTipopersona} className="form-control" name="tipo_persona_pse"  id="tipo_persona_pse">                                                         
                                                           <option  value="">Seleccione...</option>
                                                           <option  value="0">Natural</option> 
                                                           <option  value="1">Júridica</option>                                                                        
                                                        </select>
                                                                              
                                                     </div>                 
                                            </div> 
              
                                            <div className="col-md-8">                                                                          
                                                    <div className="form-group">                    
                                                        <label >Banco</label> 
                                                                                                                               
                                                        
                                                    </div>                                        
                                            </div> 
              
                                                                   
                          
                                      </div>

                                      <hr></hr>

                                    </div>

                                </div>                                  
                                                      
                                <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="BANCOLOMBIA_TRANSFER" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios3">  Bancolombia  </label>
                                            <div className="input-group-append">
                                                  <img src={bancolombia} />
                                            </div>
                                      </div>                                                        
                                           
                                </div> 

                                <br/>
                                                                 
                                                      
                              {/*  <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios4" value="NEQUI" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios4">  Nequi  </label>
                                            <div className="input-group-append">
                                                  <img src={nequi} />
                                            </div>
                                      </div>                                                                                                        
                                           
                                </div> 

                                <br/> 

                                <div className="row justify-content-md-center" id="nequi">

                                    <div className="col-sm-12">

                                      <div className="row"> 
                          
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Numero de celular (cuenta Nequi)</label>
                                                    <input type="text" maxLength="10" className="form-control" name="cel_nequi" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>
              
                                      </div>  

                                    </div>        

                                                            </div>  */}

                              </div>
                    
                          </div>

                          <div id="compra_paso3">


                                      <div className="d-flex justify-content-center">              
                                                                                                 
                                            <img src={paso3} />                                                                
                                
                                      </div>

                                       
                                      <br/> 

                                      <div className="row justify-content-md-center">

                                            <div className="col-lg-12">

                                                <div className="card" id="card_body">
                                                      <div className="card-header text-center">
                                                         <b>Detalle de la compra</b> <br/>
                                                      </div>
                                                      <div className="card-body">
                                                          <div className="row d-flex justify-content-center">
                                                       
                                                              <div className="col col-lg-5 text-right">                                                                      
                                                                 
                                                                  <b>Subtotal: </b> <br/>
                                                                  <b>IVA: </b> <br/>
                                                                  <b>Valor de la transacción: </b> <br/>
                                                                  <b>Total: </b> <br/>


                                                              </div> 
                                                              <div className="col-sm-6">                                                                      
                                                                 
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.subtotal))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.iva))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.commission))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.total))}</b> <br/>


                                                              </div>          
    
                                                          </div>
                                                      </div>
                                                </div>
            
                                            </div>
                                  
                                      </div>                                      
                                     
                              </div>
                                
                    
                          <div className="modal-footer justify-content-between" id="btn_compra_paso1">

                                <button type="button" id="btn_compra" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.dropmodal_comprar_membresia()}>Cancelar</button>
                                <button type="submit" id="btn_compra" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.validar_paso1()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Método de pago
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short" viewBox="2 3 10 10">
                                          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg> 
                                </button>

                          </div>

                          <div className="modal-footer justify-content-between" id="btn_compra_paso2">                         

                                <button type="button" id="btn_compra" className="btn btn-danger" onClick={()=> this.atras()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="currentColor" class="bi bi-arrow-left-short" viewBox="3 3 10 10">
                                          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                                        </svg>
                                        Atras
                                </button>
                                <button type="button" id="btn_compra" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.Validar_formularios_compra()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Continuar
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short" viewBox="2 3 10 10">
                                          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg> 
                                </button>

                            
                                    
                          </div>

                          <div className="modal-footer justify-content-between" id="btn_compra_paso3">                         

                                <button type="button" id="btn_compra" className="btn btn-danger" onClick={()=> this.atras3()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="currentColor" class="bi bi-arrow-left-short" viewBox="3 3 10 10">
                                          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                                        </svg>
                                        Atras
                                </button>
                                <button type="submit" id="btn_compra" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.ComprarMembresia()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Pagar
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short" viewBox="2 3 10 10">
                                          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg> 
                                </button>

                            
                                    
                          </div>

                      </form>

                    </div>
                    
                  </div>
              
              </div> 

              <div className="modal fade" id="modal_detalle_silver_independiente" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Silver Professional</b> <br/> <b>395 USD / 7.920  Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="2")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_golden_independiente" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Golden Professional</b> <br/> <b>544 USD / 15.840 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_platinum_institucion" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Platinum Business</b> <br/> <b>791 USD / 15.840 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="2")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_golden_institucion" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Golden Business</b> <br/> <b>1.087 USD / 31.680 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_diamond_institucion" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Diamond Business</b> <br/> <b>1.384 USD / 63.360 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="4")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>


              <div className="modal fade" id="modal-loader" data-backdrop="static">
                  <div className="modal-dialog modal-lg">
                    
                        <br/> <br/> <br/> <br/>
                   
                        <div className="d-flex justify-content-center">                                                
                              {this.state.loading_recurso?false: <ReactBootStrap.Spinner animation="grow"/>}                        
                        </div>
      
                        <div className="d-flex justify-content-center">                                                
                              <spam id="spamloader"> <h2>Procesando la compra</h2> </spam>                           
                        </div>                      
                    
                  </div>
  
              </div>

</div>
      
    )

  }
  
}



export default Perfil;